import { Field } from "~/interfaces/application";

export const state = () => ({
  id: 0,
  status: null,
  finalStepValidationErrors: null,
  isSendsData: false,
  isPriorityAgree: false,
  isChangedPriorityPlace: false,

  data: {
    "maindata": { //основные данные
      "lastname": { value: "" }, //фамилия (рег)
      "firstname": { value: "" }, //имя (рег)
      "surname": { value: "" }, //отчество (рег)
      "dateOfBirth": { value: "" }, //дата рождения (рег)
      "sex": { value: "" }, //пол (рег)
      "placeOfBirth": { value: "" }, //место рождения (1)
      "personalPhoto": { value: [] }, //фото (2)
      "snils": { value: "" }, // снилс (2)
      "snilsFile": { value: "" } //снилс (2)
    },
    "identity": { //удостоверение личности
      "docType": { value: "" }, //тип ДУЛ (1)
      "serial": { value: "" }, //серия ДУЛ (1)
      "number": { value: "" }, //номер ДУЛ (1)
      "date": { value: "" }, //дата выдачи ДУЛ (1)
      "departmentCode": { value: "" }, //код подразделения ДУЛ (1)
      "givenBy": { value: "" }, //кем выдан ДУЛ (1)
      "citizenship": { value: "" }, //гражданство (1)
      "passportScan": { value: [] } //скан-копии ДУЛ (1)
    },
    "previousIdentity": [ //(NEW) ранее выданные ДУЛ (3), не обязат.
      /*{
          "id": '', //(NEW)+ id ранее выданного документа (3)
          "serial": {value: ""}, //(NEW) серия ранее выданного ДУЛ (3)
          "number": {value: ""}, //номер ранее выданного ДУЛ (3)
          "date": {value: ""}, //дата выдачи ранее выданного ДУЛ (3)
          "docType": {value: ""}, // Тип ДУЛ
          "citizenship": {value: ""}, // Гражданство по ДУЛ
          "passportScan": [ //скан-копия ранее выданного ДУЛ (3)
          ]
      },*/
    ],
    "registerAddress": { //место регистрации
      "country": { value: "" }, //(NEW) страна (1)
      "index": { value: "" }, //индекс (1)
      "region": { value: "" }, //регион (1)
      "city": { value: "" }, //нас. пункт (1)
      "street": { value: "" }, //улица (1)
      "house": { value: "" }, // дом (1)
      "housing": { value: "" }, // корпус (1)
      "flat": { value: "" },
      //квартира (1)
      /*"addressObj": [{ // объект dadata
          "value": {value: ""},
          "unrestricted_value": {value: ""},
          "data": {
              "postal_code": "",
              "country": "",
              "country_iso_code": "",
              "federal_district": "",
              "region_fias_id": "",
              "region_kladr_id": "",
              "region_iso_code": "",
              "region_with_type": "",
              "region_type": "",
              "region_type_full": "",
              "region": "",
              "area_fias_id": null,
              "area_kladr_id": null,
              "area_with_type": null,
              "area_type": null,
              "area_type_full": null,
              "area": null,
              "city_fias_id": "",
              "city_kladr_id": "",
              "city_with_type": "",
              "city_type": "",
              "city_type_full": "",
              "city": "",
              "city_area": null,
              "city_district_fias_id": null,
              "city_district_kladr_id": null,
              "city_district_with_type": null,
              "city_district_type": null,
              "city_district_type_full": null,
              "city_district": null,
              "settlement_fias_id": null,
              "settlement_kladr_id": null,
              "settlement_with_type": null,
              "settlement_type": null,
              "settlement_type_full": null,
              "settlement": null,
              "street_fias_id": "",
              "street_kladr_id": "",
              "street_with_type": "",
              "street_type": "",
              "street_type_full": "",
              "street": "",
              "house_fias_id": "",
              "house_kladr_id": "",
              "house_cadnum": null,
              "house_type": "",
              "house_type_full": "",
              "house": "",
              "block_type": null,
              "block_type_full": null,
              "block": null,
              "entrance": null,
              "floor": null,
              "flat_fias_id": null,
              "flat_cadnum": null,
              "flat_type": null,
              "flat_type_full": null,
              "flat": null,
              "flat_area": null,
              "square_meter_price": null,
              "flat_price": null,
              "postal_box": null,
              "fias_id": "",
              "fias_code": "",
              "fias_level": "",
              "fias_actuality_state": "",
              "kladr_id": "",
              "geoname_id": "",
              "capital_marker": "",
              "okato": "",
              "oktmo": "",
              "tax_office": "",
              "tax_office_legal": "",
              "timezone": null,
              "geo_lat": "",
              "geo_lon": "",
              "beltway_hit": null,
              "beltway_distance": null,
              "metro": null,
              "qc_geo": "",
              "qc_complete": null,
              "qc_house": null,
              "history_values": null,
              "unparsed_parts": null,
              "source": null,
              "qc": null
          }
      }]*/
    },
    "residenceAddress": { //место фактического проживания
      "country": { value: "" }, //(NEW) страна (1)
      "index": { value: "" }, //индекс (1)
      "region": { value: "" }, //регион (1)
      "city": { value: "" }, //нас. пункт (1)
      "street": { value: "" }, //улица (1)
      "house": { value: "" }, //дом (1)
      "housing": { value: "" }, //корпус (1)
      "flat": { value: "" }, //квартира (1)
      /*"addressObj": [{ // объект dadata
          "value": "",
          "unrestricted_value": "",
          "data": {
              "postal_code": "",
              "country": "",
              "country_iso_code": "",
              "federal_district": "",
              "region_fias_id": "",
              "region_kladr_id": "",
              "region_iso_code": "",
              "region_with_type": "",
              "region_type": "",
              "region_type_full": "",
              "region": "",
              "area_fias_id": null,
              "area_kladr_id": null,
              "area_with_type": null,
              "area_type": null,
              "area_type_full": null,
              "area": null,
              "city_fias_id": "",
              "city_kladr_id": "",
              "city_with_type": "",
              "city_type": "",
              "city_type_full": "",
              "city": "",
              "city_area": null,
              "city_district_fias_id": null,
              "city_district_kladr_id": null,
              "city_district_with_type": null,
              "city_district_type": null,
              "city_district_type_full": null,
              "city_district": null,
              "settlement_fias_id": null,
              "settlement_kladr_id": null,
              "settlement_with_type": null,
              "settlement_type": null,
              "settlement_type_full": null,
              "settlement": null,
              "street_fias_id": "",
              "street_kladr_id": "",
              "street_with_type": "",
              "street_type": "",
              "street_type_full": "",
              "street": "",
              "house_fias_id": "",
              "house_kladr_id": "",
              "house_cadnum": null,
              "house_type": "",
              "house_type_full": "",
              "house": "",
              "block_type": null,
              "block_type_full": null,
              "block": null,
              "entrance": null,
              "floor": null,
              "flat_fias_id": null,
              "flat_cadnum": null,
              "flat_type": null,
              "flat_type_full": null,
              "flat": null,
              "flat_area": null,
              "square_meter_price": null,
              "flat_price": null,
              "postal_box": null,
              "fias_id": "",
              "fias_code": "",
              "fias_level": "",
              "fias_actuality_state": "",
              "kladr_id": "",
              "geoname_id": "",
              "capital_marker": "",
              "okato": "",
              "oktmo": "",
              "tax_office": "",
              "tax_office_legal": "",
              "timezone": null,
              "geo_lat": "",
              "geo_lon": "",
              "beltway_hit": null,
              "beltway_distance": null,
              "metro": null,
              "qc_geo": "",
              "qc_complete": null,
              "qc_house": null,
              "history_values": null,
              "unparsed_parts": null,
              "source": null,
              "qc": null
          }
      }]*/
    },
    "representativePerson": { //(NEW) данные представителя (1)
      "document": { value: "" }, //(NEW) Документ, подтверждающий основание законного представителя, новый справочник(?) (1)
      "lastname": { value: "" }, //(NEW) фамилия представителя (1)
      "firstname": { value: "" }, //(NEW) имя представителя (1)
      "surname": { value: "" }, //(NEW) отчество представителя (1)
      "docType": { value: "" }, //(NEW) тип ДУЛ представителя (1)
      "serial": { value: "" }, //(NEW) серия ДУЛ представителя (1)
      "number": { value: "" }, //(NEW) номер ДУЛ представителя (1)
      "phone": { value: "" }, //(NEW) телефон представителя (1)
      "email": { value: "" }, //(NEW) email представителя (1)
      "country": { value: "" }, //(NEW) страна регистрации представителя (1)
      "region": { value: "" }, //(NEW) регион регистрации представителя (1)
      "city": { value: "" }, //(NEW) нас. пункт регистрации представителя (1)
      "street": { value: "" }, //(NEW) улица регистрации представителя (1)
      "house": { value: "" }, //(NEW) дом регистрации представителя (1)
      "housing": { value: "" }, //(NEW) корпус регистрации представителя (1)
      "flat": { value: "" }, //(NEW) квартира регистрации представителя (1)
      "index": { value: "" }
      /*"addressObj": [{ //(NEW) объект dadata регистрации представителя (1)
          "value": "",
          "unrestricted_value": "",
          "data": {
              "postal_code": "",
              "country": "",
              "country_iso_code": "",
              "federal_district": "",
              "region_fias_id": "",
              "region_kladr_id": "",
              "region_iso_code": "",
              "region_with_type": "",
              "region_type": "",
              "region_type_full": "",
              "region": "",
              "area_fias_id": null,
              "area_kladr_id": null,
              "area_with_type": null,
              "area_type": null,
              "area_type_full": null,
              "area": null,
              "city_fias_id": "",
              "city_kladr_id": "",
              "city_with_type": "",
              "city_type": "г",
              "city_type_full": "",
              "city": "",
              "city_area": null,
              "city_district_fias_id": null,
              "city_district_kladr_id": null,
              "city_district_with_type": null,
              "city_district_type": null,
              "city_district_type_full": null,
              "city_district": null,
              "settlement_fias_id": null,
              "settlement_kladr_id": null,
              "settlement_with_type": null,
              "settlement_type": null,
              "settlement_type_full": null,
              "settlement": null,
              "street_fias_id": "",
              "street_kladr_id": "",
              "street_with_type": "",
              "street_type": "",
              "street_type_full": "",
              "street": "",
              "house_fias_id": "",
              "house_kladr_id": "",
              "house_cadnum": null,
              "house_type": "",
              "house_type_full": "",
              "house": "",
              "block_type": null,
              "block_type_full": null,
              "block": null,
              "entrance": null,
              "floor": null,
              "flat_fias_id": null,
              "flat_cadnum": null,
              "flat_type": null,
              "flat_type_full": null,
              "flat": null,
              "flat_area": null,
              "square_meter_price": null,
              "flat_price": null,
              "postal_box": null,
              "fias_id": "",
              "fias_code": "",
              "fias_level": "",
              "fias_actuality_state": "",
              "kladr_id": "",
              "geoname_id": "",
              "capital_marker": "",
              "okato": "",
              "oktmo": "",
              "tax_office": "",
              "tax_office_legal": "",
              "timezone": null,
              "geo_lat": "",
              "geo_lon": "",
              "beltway_hit": null,
              "beltway_distance": null,
              "metro": null,
              "qc_geo": "",
              "qc_complete": null,
              "qc_house": null,
              "history_values": null,
              "unparsed_parts": null,
              "source": null,
              "qc": null
          }
      }]*/
    },
    "trustedPerson": { //(NEW) данные доверенного лица представителя (1)
      "lastname": { value: "" }, //(NEW) фамилия доверенного лица представителя (1)
      "firstname": { value: "" }, //(NEW) имя доверенного лица представителя (1)
      "surname": { value: "" }, //(NEW) отчество доверенного лица представителя (1)
      "docType": { value: "" }, //(NEW) тип ДУЛ доверенного лица представителя (1)
      "serial": { value: "" }, //(NEW) серия ДУЛ доверенного лица представителя (1)
      "number": { value: "" }, //(NEW) номер ДУЛ доверенного лица представителя (1)
      "phone": { value: "" }, //(NEW) телефон доверенного лица представителя (1)
      "email": { value: "" }, //(NEW) email доверенного лица представителя (1)
      "country": { value: "" }, //(NEW) страна регистрации доверенного лица представителя (1)
      "region": { value: "" }, //(NEW) регион регистрации доверенного лица представителя (1)
      "city": { value: "" }, //(NEW) нас. пункт регистрации доверенного лица представителя (1)
      "street": { value: "" }, //(NEW) улица регистрации доверенного лица представителя (1)
      "house": { value: "" }, //(NEW) дом регистрации доверенного лица представителя (1)
      "housing": { value: "" }, //(NEW) корпус регистрации доверенного лица представителя (1)
      "flat": { value: "" }, //(NEW) квартира регистрации доверенного лица представителя (1)
      "index": { value: "" }
      /*"addressObj": [{ //(NEW) объект dadata регистрации доверенного лица представителя (1)
          "value": "",
          "unrestricted_value": "",
          "data": {
              "postal_code": "",
              "country": "",
              "country_iso_code": "",
              "federal_district": "",
              "region_fias_id": "",
              "region_kladr_id": "",
              "region_iso_code": "",
              "region_with_type": "",
              "region_type": "",
              "region_type_full": "",
              "region": "",
              "area_fias_id": null,
              "area_kladr_id": null,
              "area_with_type": null,
              "area_type": null,
              "area_type_full": null,
              "area": null,
              "city_fias_id": "",
              "city_kladr_id": "",
              "city_with_type": "",
              "city_type": "",
              "city_type_full": "",
              "city": "",
              "city_area": null,
              "city_district_fias_id": null,
              "city_district_kladr_id": null,
              "city_district_with_type": null,
              "city_district_type": null,
              "city_district_type_full": null,
              "city_district": null,
              "settlement_fias_id": null,
              "settlement_kladr_id": null,
              "settlement_with_type": null,
              "settlement_type": null,
              "settlement_type_full": null,
              "settlement": null,
              "street_fias_id": "",
              "street_kladr_id": "",
              "street_with_type": "",
              "street_type": "",
              "street_type_full": "",
              "street": "",
              "house_fias_id": "",
              "house_kladr_id": "",
              "house_cadnum": null,
              "house_type": "",
              "house_type_full": "",
              "house": "",
              "block_type": null,
              "block_type_full": null,
              "block": null,
              "entrance": null,
              "floor": null,
              "flat_fias_id": null,
              "flat_cadnum": null,
              "flat_type": null,
              "flat_type_full": null,
              "flat": null,
              "flat_area": null,
              "square_meter_price": null,
              "flat_price": null,
              "postal_box": null,
              "fias_id": "",
              "fias_code": "",
              "fias_level": "",
              "fias_actuality_state": "",
              "kladr_id": "",
              "geoname_id": "",
              "capital_marker": "",
              "okato": "",
              "oktmo": "",
              "tax_office": "",
              "tax_office_legal": "",
              "timezone": null,
              "geo_lat": "",
              "geo_lon": "",
              "beltway_hit": null,
              "beltway_distance": null,
              "metro": null,
              "qc_geo": "0",
              "qc_complete": null,
              "qc_house": null,
              "history_values": null,
              "unparsed_parts": null,
              "source": null,
              "qc": null
          }
      }]*/
    },
    "agreementPD": [ //(NEW) подписанные сканы согласния на обработку ПД (1)
    ],
    "contacts": {
      "phone": { value: "" }, //телефон (рег)
      "phoneHome": { value: "" }, //телефон доп. (2)
      "phoneWork": { value: "" }, //резерв поля
      "email": { value: "" }, //основной email (рег)
      "emailExtra": { value: "" } //(NEW) доп. email (2)
    },
    "compatriot": [ //(NEW) соотечественник (4)
      /*{
          "id": 0, //(NEW)+ id записи документа соотечественника (4)
          "document": {value: ""}, //(NEW) Наименование документа, подтверждающего статус соотечественника (4)
          "serial": "", //(NEW) серия документа, подтверждающего статус соотечественника (4)
          "number": "", //(NEW) номер документа, подтверждающего статус соотечественника (4)
          "date": "", //(NEW) дата выдачи документа, подтверждающего статус соотечественника (4)
          "docType": "", //(NEW) тип документа, подтверждающего статус соотечественника, новый справочник(?) (4)
          "givenBy": "", //(NEW) кем выдан документ, подтверждающий статус соотечественника (4)
          "extraInfo": "", //(NEW) доп. информация (4)
          "documentScan": [ //(NEW) сканы документа подтверждающего статус соотечественника (4)
          ]
      },
      {} // это мультиблок*/
    ],
    "eduDocuments": { //документ об образовании
      "IsHse": { value: false },
      "eduLevel": { value: "" }, //(NEW) уровень имеющегося образования, справочник (?) (5)
      "givenCountry": { value: "" }, //страна выдачи ДО (5)
      "docType": { value: "" }, //вид ДО (5)
      "givenRegion": { value: "" }, //регион выдачи ДО (5)
      "givenLocation": { value: "" }, //город выдачи ДО (5)
      "date": { value: "" }, //дата выдачи ДО (5)
      "serial": { value: "" }, //серия ДО (5)
      "number": { value: "" }, //номер ДО (5)
      "schoolType": { value: "" }, //(NEW) Тип учебного заведения, новый справочник(?) (5)
      "givenBy": { value: "" }, //наименование учебного заведения (5)
      "avgMark": { value: "" }, //средний балл, вычисляется (5)
      "honorsDoc": { value: false }, //(NEW) ДО с отличием (5)
      "eduDocFiles": { value: [] } //сканы ДО (5)
    },
    "egeResults": [ //результаты ЕГЭ, мультиблок (6)
      /*{
          "id": 0, //(NEW)+ id записи егэ (6)
          "GUIDSubject": "", //дисциплина ЕГЭ (6)
          "Mark": "", //балл ЕГЭ (6)
          "Year": "" //год ЕГЭ (6)
      },
      {},*/
    ],
    "CT": [ //(NEW) Централизованное тестирование (для граждан РБ) (6)
      /*{
          "id": 0, //(NEW)+ id записи цт (6)
          "GUIDSubject": "", //(NEW) Дисциплина ЦТ (6)
          "Mark": "", //(NEW) Балл ЦТ (6)
          "Year": "", //(NEW) Год ЦТ (6)
          "CTFiles": [ //(NEW) сканы сертификата ЦТ (6)
          ]
      },
      {} //это мультиблок*/
    ],
    "contactPersons": [ //контактные лица (13)
      /*{
          "id": 0, //(NEW)+ id записи контактного лица (13)
          "GUIDRelationType": "", //тип родства (13)
          "FIO": "", //ФИО контактного лица, вычисляется (13)
          "Tel": "", //телефон контактного лица (13)
          "Email": "" //(NEW) email контактного лица (13)
      },
      {} //(NEW) это мультиблок теперь (13)*/
    ],
    "foreignLanguages": [{ //иностранный язык, изучаемый в школе (5)
      "GUIDLanguage": { value: "" }, //иностранный язык, изучаемый в школе (5)
      "IsMain": false //всегда так
    }],
    "personalAchievments": [/*{ //индивидуальные достижения (8)
              "id": 0, //(NEW)+ id документа ИД (8)
              "IndividualAchievementGroupType": "", //(NEW) Группа ИД, новый справочник (?) (8)
              "IndividualAchievementDocType": "", //тип ИД (8)
              "givenBy": "", // Кем выдан
              "IndividualAchievementGuid": "", // ACHIEVEMENT_TYPE
              "OlympiadGuid": "", //(NEW) Олимпиада или конкурс ИД, новый справочник (?) (8)
              "OlympiadLevelGuid": "", //уровень участия в конкурсе или олимпиада, справочник от олимпиад (?) (8)
              "Number": "", //номер документа ИД (8)
              "Date": "", //дата документа ИД (8)
              "FilePath": [ //скан-копия ИД (8)
              ]
          },
          {} //это мультиблок*/
    ],
    "olimpicDiplomas": [/*{ //дипломы олимпиад (7)
              "id": 0, //(NEW) id записи олимпиады (7)
              "OlympicDocOlympiadeYear": "", //год олимпиады (7)
              "OlympicDocOlympiadeProfileGuid": "", //профиль олимпиады (7)
              "OlympicDocOlympiadeGuid": "", //название олимпиады (7)
              "OlympicDocOlympiadeDisciplineGuid": "", //(NEW) Дисциплина олимпиады (7)
              "OlympicDocOlympiadeClassGuid": "", //класс участия (7)
              "OlympicDocDiplomaTypeGuid": "", //результат участия (7)
              "Number": "", //номер диплома (или номер приказа) (7)
              "Date": "", //дата диплома (или номер приказа) (7)
              "FilePath": [ //скан-копия диплома
              ],
              "OlympicDocVOSStage": "", //(NEW) Этап всероссийской олимпиады школьников, новый справочник (?) (7)
              "isRu": false
          },
          {} //это мультиблок*/
    ],
    "olimpicDiplomasInternational": [
      /*"id",
      "Country",
      "OlympicName",
      "Number",
      "OlympicDocOlympiadeProfileGuid",
      "OlympicDocDiplomaTypeGuid",
      "OlympicDocOlympiadeYear",
      "OlympicDate",
      "FilePath"*/
    ],
    "olimpicDiplomasUkraine": [
      /*id
      Number
      OlympicDocDiplomaTypeGuid
      OlympicName
      OlympicDocOlympiadeProfileGuid
      OlympicDate
      FilePath
      OlympicDocOlympiadeYear*/
    ],
    "specialQuota": [ //(NEW) Документы особой квоты (9)
      /*{
          "id": 0, //(NEW)+ id документа особой квоты (9)
          "benefitTypeGuid": "", //(NEW)+ тип льготы особого права, новый справочник(?) (9)
          "benefitHandicapDocGuid": "", //(NEW)+ документ, подтверждающий инвалидность, новый справочник(?) (9)
          "benefitHandicapGroup": "", //(NEW)+ группа инвалидности, новый справочник(?) (9)
          "benefitHandicapCategory": "", //(NEW)+ категория льготы по инвалидности, новый справочник(?) (9)
          "benefitOrphanageDocGuid": "", //(NEW)+ документ, подтверждающий сиротство, новый справочник(?) (9)
          "benefitOrphanageCategory": "", //(NEW)+ категория льготы по сиротству, новый справочник(?) (9)
          "benefitCombanantDocGuid": "", //(NEW)+ документ, подтверждающий принадлежность к участникам боевых действий, новый справочник(?) (9)
          "benefitCombanantCategory": "", //(NEW)+ категория льготы по принадлежности к участникам боевых действий, новый справочник(?) (9)
          "Serial": "", //(NEW)+ серия документа особого права (9)
          "Number": "", //(NEW)+ номер документа особого права (9)
          "dateFrom": "", //(NEW)+ дата начала действия документа особого права (9)
          "dateTill": "", //(NEW)+ дата окончания действия документа особого права (9)
          "datePerpetual": true, //(NEW)+ документ особого права бессрочный (9)
          "givenBy": "", //(NEW)+ организация, выдавшая документ особого права (9)
          "comment": "", //(NEW)+ комментарий к документу особого права (9)
          "countAsPriority": true, //(NEW)+ зачесть документ в качестве преимущественного права (9)
          "birthCertificate": [ //(NEW)+ скан-копия свидетельства о рождении (9)
          ],
          "FilePath": [ //(NEW)+ скан-копия документа, подтверждающего статус особой квоты (9)
          ]
      },
      {} // Мультиблок*/
    ],
    "newRegionScanAgree": {},
    "extraQuota": [],
    "ldnrQuota": [],
    "newRegionRf": [],
    "priorityRights": [ //(NEW) Документы преимущественного права (10)
      /*{
          "id": 0, //(NEW)+ id документа преимущ. права (10)
          "benefitTypeGuid": "", //(NEW)+ тип льготы преимущественного права, новый справочник(?) (10)
          "benefitCategory": "", //(NEW)+ категория льготы преимущественного права, новый справочник(?) (10)
          "benefitDocType": "", // тип документа преимущественного права
          "Serial": "", //(NEW)+ серия документа преимущественного права (10)
          "Number": "", //(NEW)+ номер документа преимущественного права (10)
          "Date": "", //(NEW)+ дата документа преимущественного права (10)
          "givenBy": "", //(NEW)+ организация, выдавшая документ преимущественного права (10)
          "FilePath": [ //(NEW)+ скан-копия документа, подтверждающего статус преимущественного права (10)
          ]
      },
      {} //это мультиблок*/
    ],
    "targetedEducation": [ //(NEW)+ Целевое обучение (12)
      /*{
          "id": 0, //(NEW)+ id документа целевого обучения (12)
          "contractNumber": "", //(NEW)+ номер договора (12)
          "contractDate": "", //(NEW)+ дата договора (12)
          "contractCompany": "", //(NEW)+ организация, заключившая договор (12)
          "regionCompany": "", //(NEW)+ регион работодателя, справочник (?) (12)
          "customerCompany": "", //(NEW)+ наименования заказчика по договору (12)
          "contractEduField": [ //(NEW)+ направления подготовки по договору (12)
          ],
          "contractEduProgram": [ //(NEW)+ образовательные программы по договору (12)
          ],
          "contractCampus": [ //(NEW)+ кампусы по договору (12)
          ],
          "comment": "", //(NEW)+ доп. информация к договору (12)
          "FilePath": [ //(NEW)+ скан-копия договора (12)
          ]
      },*/
    ],
    "socialElevator": { //(NEW) социальный лифт
      "isApplicable": { value: false }, //(NEW) заявлено право на соц. льготу по Социальному Лифту (11),
      "FilePath": { value: [] } //(NEW) документы, подтверждающие соц. льготу по социальному лифту (11)
    },
    "otherInfo": { //прочие отдельные реквизиты
      "NeedHostel": { value: false }, //требуется общежитие (18),
      "NeedAltHostel": { value: false }, // Требуется альтернативное размещение (18)
      "HostelCampus": { value: [] }, // (NEW) кампус заявки на общежитие (18)
      "HsePlus": { value: false },
      "epguAgreement": { value: false }
    },
    "competiveGroup": [/*{ //выбор образовательной программы (14)
              "GUIDCompetitiveGroup": "", //конкурсная группа (в КГ уже содержится вид места, образовательная программа, кампус и направление) (14)
              "Specialization": "", //(NEW) специализация, новый справочник (?) (14)
              "specialQuotaDoc": 0, //(NEW) документ, подтверждающий особую квоту (14)
              "targetedEducationDoc": 0, //(NEW) документ, подтверждающий целевое обучение (14)
              "benefitNoExam": 0,
              "benefitHundredPoints": [
              ]
          },
          {
              "GUIDCompetitiveGroup": "",
              "Specialization": "",
              "specialQuotaDoc": 0,
              "targetedEducationDoc": 0,
              "Status": "",
              "benefitNoExam": false,
              "benefitHundredPoints": [
              ]
          }*/
    ],
    "innerExams": { //Данные об условиях доступа к вступительным испытаниям (16)
      "docExamRights": { value: "" }, //(NEW)+ Основание допуска к ВИ, новый справочник(?) (16)
      "fileExamRights": { value: [] }, //(NEW)+ Скан-копия документа, подтверждающего основание допуска к ВИ  (16)
      "chosenDisciplines": { value: [] }, //(NEW)+ Какие ВИ абитуриент намерен сдавать, служебное (16)
      "isHandicaped": { value: false }, //(NEW)+ Наличие ограниченных возможностей здоровья  (16)
      "handicape": { value: "" }, //(NEW)+ Ограничение возможностей здоровья, новый справочник(?) (16)
      "handicapeType": { value: "" }, //(NEW)+ Вид ограничений возможностей здоровья , новый справочник(?) (16),
      "handicapeDisorderType": { value: "" }, //(NEW)+ Вид заболевания, новый справочник(?) (16),
      "handicapeCategory": { value: "" }, //(NEW)+ Категория ограничений возможностей здоровья, новый справочник(?) (16),
      "handicapeDocumentType": { value: "" }, //(NEW)+ Вид документа ограничений возможностей здоровья, новый справочник(?) (16),
      "handicapeSerial": { value: "" }, //(NEW)+ серия документа (16)
      "handicapeNumber": { value: "" }, //(NEW)+ номер документа  (16)
      "handicapeDateFrom": { value: "" }, //(NEW)+ дата начала действия документа  (16)
      "handicapeDateTill": { value: "" }, //(NEW)+ дата окончания действия документа  (16)
      "handicapeDatePerpetual": { value: false }, //(NEW)+ документ  бессрочный  (16)
      "handicapeGivenBy": { value: "" }, //(NEW)+ организация, выдавшая документ  (16)
      "handicapeDoc": { value: [] },
      "specialConditionsRequired": { value: false }, //(NEW)+ Требуются специальные условия для участия во вступительных испытаниях (16)
      "specialConditionsHandicape": { value: "" }, //(NEW)+ Ограничение возможностей здоровья, обуславливающие спец.условия, (16)
    },
    "nostrification": { //нострификация (5)
      "eduLevel": { value: "" }, //(NEW)+ уровень имеющегося образования, справочник (?) (5)
      "givenCountry": { value: "" }, //(NEW)+ страна выдачи ДО (5)
      "GUIDLanguage": { value: "" }, //(NEW)+ язык документа об образовании (5)
      "docName": { value: "" }, //(NEW)+ название доку-та об ИОК на рус. или англ (5)
      "date": { value: "" }, //(NEW)+ дата выдачи док. ИОК (5)
      "serial": { value: "" }, //(NEW)+ серия док. ИОК (5)
      "number": { value: "" }, //(NEW)+ номер док. ИОК (5)
      "eduInstitutionType": { value: "" }, //(NEW)+ форма образ. организации, справочник (?) (5)
      "diplomaDegreeTitle": { value: "" }, //(NEW)+ название присвоенной степени (5)
      "hasNostrification": { value: false }, //(NEW)+ есть свидетельство о признании (5)
      "nostrificatedDiploma": { value: [] }, //(NEW)+ скан Свидетельство о признании (5)
      "credits": 0, //(NEW)+ кол-во полученных кредитов (5)
      "studyDuration": { value: "" }, //(NEW)+ нормативная продолж. обучения (5)
      "prevEducationEduForm": { value: "" }, //(NEW)+ форма получения предыдущего образования, справочник форм обучения (?) (5)
      "academicProfessionalRights": { value: "" }, //(NEW)+ академич. и профес-ные права (5)
      "diplomaCertified": { value: [] }, //(NEW)+ заверенный скан ДОО (5)
      "diplomaCertifiedTranslation": { value: [] }, //(NEW)+ заверенный скан перевода ДОО с прилож. (5)
      "passportCertifiedTranslation": { value: [] }, //(NEW)+ заверенный скан ДУЛ (5)
      "extraNostificationDocuments": { value: [] }, //(NEW)+ доп. документ для признания оригинала док. ИОК (5)
      "extraQualificationDocuments": { value: [] }, //(NEW)+ доп. документы о подготовке (5)
    },
    "applicationPrintForm": [ // (NEW) Печатные формы заявки (18)
      /*{
          "campus": "", //(NEW) кампус (18)
          "FilePath": [ //(NEW) сканы печатной формы (18)
          ]
      },
      {} //это мультиблок*/
    ],
    "priorityPlace": { // Приоритеты
      /*
      budgetPriority: []
      commercePriority: []
      */
    }
  },

  fieldsStep: {}
});

export const actions = {
  async send({ commit, state, dispatch, rootGetters }, params) {
    // FIXME: DISABLE EDIT
    return;
    await dispatch('beforeSend', params)
    if (rootGetters['application/getAppFormViewMode'] === 'view') {
      return
    }
    commit("SET_STATE_SEND", true)
    switch (params.step) {
      case "step_1":
        try {
          const dataFirstStep = {
            "identity": state.data.identity,
            "registerAddress": state.data.registerAddress,
            "residenceAddress": state.data.residenceAddress,
            "representativePerson": state.data.representativePerson,
            "trustedPerson": state.data.trustedPerson,
            "agreementPD": state.data.agreementPD
          };

          await dispatch('setFieldStep', { data: dataFirstStep, step: params.step });
          const response = await this.$api("applicantForm", {
            "formStep": 'applicantFirstStep',
            data: dataFirstStep
          }, "POST")
          commit('setId', { "id": response.data.id })
        } catch (error) {
          console.error(error);
        } finally {
          commit("SET_STATE_SEND", false);
        }
        break;
      case "step_19":
        await this.$api("applicantForm", {
          "formStep": 'applicantFinalStep',
          "id": state.id,
          "data": state.data/*{
                //"applicationPrintForm": state.data.applicationPrintForm
              }*/
        }, "POST")
          .then(() => {
            commit("SET_ERROR", null)
            commit("SET_STATUS", true)
          })
          .catch(async (error) => {
            await dispatch('setError', error);
            commit('SET_STATUS', false)
          })
          .finally(() => {
            commit("SET_STATE_SEND", false)
          })
        break;
      default:
        let data = {}
        switch (params.step) {
          case "step_2":
            data = {
              "maindata": state.data.maindata,
              "contacts": state.data.contacts
            }
            break;
          case "step_3":
            data = {
              "previousIdentity": state.data.previousIdentity
            }
            break;
          case "step_4":
            data = {
              "compatriot": state.data.compatriot
            }
            break;
          case "step_5":
            data = {
              "eduDocuments": state.data.eduDocuments,
              "nostrification": state.data.nostrification,
              "foreignLanguages": state.data.foreignLanguages
            }
            break;
          case "step_6":
            data = {
              "egeResults": state.data.egeResults,
              "CT": state.data.CT
            }
            break;
          case "step_7":
            data = {
              "olimpicDiplomas": state.data.olimpicDiplomas,
              "olimpicDiplomasInternational": state.data.olimpicDiplomasInternational,
              "olimpicDiplomasUkraine": state.data.olimpicDiplomasUkraine
            }
            break;
          case "step_8":
            data = {
              "personalAchievments": state.data.personalAchievments
            }
            break;
          case "step_9":
            data = {
              "specialQuota": state.data.specialQuota,
              "extraQuota": state.data.extraQuota,
              "ldnrQuota": state.data.ldnrQuota,
              "newRegionRf": state.data.newRegionRf ?? [],
              "newRegionScanAgree": state.data.newRegionScanAgree
            }
            break;
          case "step_10":
            data = {
              "priorityRights": state.data.priorityRights
            }
            break;
          case "step_11":
            data = {
              "socialElevator": state.data.socialElevator
            }
            break;
          case "step_12":
            data = {
              "targetedEducation": state.data.targetedEducation
            }
            break;
          case "step_13":
            data = {
              "contactPersons": state.data.contactPersons
            }
            break;
          case "step_14":
            data = {
              //"competiveGroup": state.data.competiveGroup
            }
            break;
          case "step_15":
            data = {
              "competiveGroup": state.data.competiveGroup
            }
            break;
          case "step_16":
            data = {
              "priorityPlace": state.data.priorityPlace
            }
            break;
          case "step_17":
            data = {
              "innerExams": state.data.innerExams
            }
            break;
          case "step_18":
            data = {
              "otherInfo": state.data.otherInfo
            }
            break;
          default:
            data = {}
        }
        await dispatch('setFieldStep', { data, step: params.step });

        await this.$api("applicantForm", {
          "formStep": 'applicantStep',
          "id": state.id,
          "data": data
        }, "POST")
          .then(async (response) => {
            if (response.data.multiblocksIds) {
              let multiblocks = response.data.multiblocksIds;
              for await (let key of Object.keys(multiblocks)) {
                if (key !== 'competiveGroup') {
                  this.dispatch('multiBlocks/setIds', { name: key, ids: multiblocks[key] })
                } else {
                  await this.dispatch('application/setGuidSelectedCompetition', multiblocks[key])
                  await dispatch('setPriorityPlace', {
                    competitiveGroups: this.getters['application/getCompetitiveGroups'],
                    selectedCompetitionGroupGUID: this.getters['application/getGUIDSelectedCompetitionGroup'],
                  })
                }
              }
            }
            commit("SET_ERROR", null)
          })
          .catch(error => {
            commit("SET_ERROR", error)
          })
          .finally(() => {
            commit("SET_STATE_SEND", false)
          })
        break;
    }
  },
  beforeSend({ commit, rootGetters }, params) {
    if (params.step === 'step_5') {
      params.data = params.data.filter((e) => e.blockActive || e.code === 'EDUCATION_DOCUMENT_TYPE')
    }
    params.data.forEach((e) => {
      delete e.blockActive
    })
    commit('send', params)
  },
  async refresh({ commit }, params) {
    await commit('send', params);
  },
  setFinalErrors: ({ commit }, params) => {
    commit('SET_ERROR', params);
  },
  setPriorityPlace: ({ commit, state, getters }, params) => {
    const { competitiveGroups, selectedCompetitionGroupGUID } = params;
    const result = {
      budgetPriority: [],
      commercePriority: [],
      unknownPriority: [],
    }


    let priorityUnknown = 1;
    if (Array.isArray(competitiveGroups) && Array.isArray(selectedCompetitionGroupGUID)) {
      if (!getters['priorityPlaceIsEmpty']) {
        selectedCompetitionGroupGUID.forEach((e) => {
          const bPriority = state.data.priorityPlace?.budgetPriority?.find((el) => el.competitiveGroup === e.GUID);
          const cPriority = bPriority ? '' : state.data.priorityPlace?.commercePriority?.find((el) => el.competitiveGroup === e.GUID);
          const uPriority = bPriority || cPriority ? '' : priorityUnknown;

          if (bPriority) {
            result.budgetPriority.push({
              priority: +bPriority.priority,
              competitiveGroup: e.GUID,
            })
          } else if (cPriority) {
            result.commercePriority.push({
              priority: +cPriority.priority,
              competitiveGroup: e.GUID,
            })
          } else if (uPriority) {
            result.unknownPriority.push({
              priority: +uPriority,
              competitiveGroup: e.GUID,
            })
            priorityUnknown += 1;
          }
        })
      } else {
        competitiveGroups.forEach((e) => {
          const tempGuid = selectedCompetitionGroupGUID.find((el) => el.competitionGroupId == e.id)?.GUID
          if (tempGuid) {
            if (e.budgetPriority) {
              result.budgetPriority.push({
                priority: +e.budgetPriority,
                competitiveGroup: tempGuid,
              })
            } else if (e.commercePriority) {
              result.commercePriority.push({
                priority: +e.commercePriority,
                competitiveGroup: tempGuid,
              })
            } else {
              result.unknownPriority.push({
                priority: priorityUnknown,
                competitiveGroup: tempGuid,
              })
              priorityUnknown += 1;
            }
          }
        })
        selectedCompetitionGroupGUID.forEach((e) => {
          if (!competitiveGroups.find((el) => el.id === e.competitionGroupId)) {
            result.unknownPriority.push({
              priority: priorityUnknown,
              competitiveGroup: e.GUID
            })
          }
        })
      }
    }

    result.budgetPriority = result.budgetPriority.sort((a, b) => a.priority - b.priority)
    result.commercePriority = result.commercePriority.sort((a, b) => a.priority - b.priority)
    result.unknownPriority = result.unknownPriority.sort((a, b) => a.priority - b.priority)

    commit('setPriorityPlace', result)
  },
  initPriorityPlace({ commit }, { responseCompetitiveGroups }) {
    if (Array.isArray(responseCompetitiveGroups)) {
      const result = {
        budgetPriority: [],
        commercePriority: [],
        unknownPriority: [],
      }

      responseCompetitiveGroups.forEach((e) => {
        if (e.guid) {
          if (e.budgetPriority) {
            result.budgetPriority.push({
              priority: +e.budgetPriority,
              competitiveGroup: e.guid
            })
          }
          if (e.commercePriority) {
            result.commercePriority.push({
              priority: +e.commercePriority,
              competitiveGroup: e.guid
            })
          }
        }
      })

      result.budgetPriority = result.budgetPriority.sort((a, b) => a.priority - b.priority)
      result.commercePriority = result.commercePriority.sort((a, b) => a.priority - b.priority)

      commit('setPriorityPlace', result)
    }
  },
  setFieldStep({ commit }, params) {
    if (params.data && params.step) {
      const fieldValue = params.step.split('_').at(-1);
      commit('SET_FIELD_STEP', { field: fieldValue, value: Object.keys(params.data) })
    }
  },
  setError({ commit, getters }, params) {
    const findStepByProperty = (property) => {
      let step = '';
      const pathState = property.split('.').filter((e) => e !== 'data' && e !== '')
      if (pathState.length) {
        const firstField = pathState[0];
        step = getters['getStepByField'](firstField)
      }

      return step;
    }

    const makeErrorByStep = (steps, responseMessage) => {
      const info = `При проверке данных в анкете возникли ошибки на шагах ${steps.join(', ')}. Пожалуйста, воспользуйтесь пошаговой навигацией в правой части экрана чтобы перейти на нужный шаг и исправить ошибку`
      const result = {
        message: responseMessage + '. ' + info,
      }
      return result
    }

    if (Array.isArray(params?.data) && params.data.length) {
      const arrStep = []
      params.data.forEach((e) => {
        const step = findStepByProperty(e.property);
        if (step && !arrStep.includes(step)) {
          arrStep.push(step)
        }
      })
      const newError = arrStep.length ? makeErrorByStep(arrStep, params.message ?? '') : params;
      commit('SET_ERROR', newError)
    } else {
      commit('SET_ERROR', params)
    }
  }
}

export const mutations = {
  send(state, params) {
    const data = {}
    const paramsArray = params.data;
    if (paramsArray || params.multipleBlocks) {
      if (paramsArray) {
        paramsArray.forEach(item => {
          if (data[item.code] && data[item.code].value && !item.value) {
            //
          } else {
            data[item.code] = item;
          }
        })
      }
      const residencyFill = params.residencyFill
      switch (params.step) {
        case "step_1":
          state.data.maindata.placeOfBirth = data["DOCUMENT_BIRTHPLACE"];
          state.data.identity.citizenship = data["DOCUMENT_CITIZENSHIP"];
          state.data.identity.docType = data["DOCUMENT_TYPE"];

          if (!data['DOCUMENT_NUMBER'].value) {
            data['DOCUMENT_NUMBER'].value = "";
          }

          state.data.identity.number = data["DOCUMENT_NUMBER"];

          if (!data['DOCUMENT_SERIAL'].value) {
            data['DOCUMENT_SERIAL'].value = "";
          }

          state.data.identity.serial = data["DOCUMENT_SERIAL"];
          state.data.identity.givenBy = data["DOCUMENT_GIVENBY"];

          if (!data['DOCUMENT_DIVISION_CODE'].value) {
            data['DOCUMENT_DIVISION_CODE'].value = "";
          }

          state.data.identity.departmentCode = data["DOCUMENT_DIVISION_CODE"];
          state.data.identity.date = data["DOCUMENT_DATE"];
          //_2
          state.data.identity.passportScan = data["DOCUMENT_SCANS"]
          //_3
          state.data.registerAddress.country = data["REGISTRATION_COUNTRY"];

          if (!data['REGISTRATION_REGION'].value) {
            data['REGISTRATION_REGION'].value = "";
          }

          state.data.registerAddress.region = data["REGISTRATION_REGION"];
          state.data.registerAddress.city = data["REGISTRATION_SETTLEMENT"];

          if (!data['REGISTRATION_STREET'].value) {
            data['REGISTRATION_STREET'].value = "";
          }

          state.data.registerAddress.street = data["REGISTRATION_STREET"];
          state.data.registerAddress.house = data["REGISTRATION_BUILDING"];

          if (!data['REGISTRATION_BUILDING_KORP'].value) {
            data['REGISTRATION_BUILDING_KORP'].value = "";
          }

          state.data.registerAddress.housing = data["REGISTRATION_BUILDING_KORP"];

          if (!data['REGISTRATION_APARTMENT'].value) {
            data['REGISTRATION_APARTMENT'].value = "";
          }

          state.data.registerAddress.flat = data["REGISTRATION_APARTMENT"];
          state.data.registerAddress.index = data["REGISTRATION_INDEX"];

          state.data.residenceAddress.country = residencyFill ?
            data["REGISTRATION_COUNTRY"] :
            data["RESIDENCY_COUNTRY"];
          state.data.residenceAddress.region = residencyFill ?
            data["REGISTRATION_REGION"] :
            data["RESIDENCY_REGION"];
          state.data.residenceAddress.city = residencyFill ?
            data["REGISTRATION_SETTLEMENT"] :
            data["RESIDENCY_SETTLEMENT"];
          state.data.residenceAddress.street = residencyFill ?
            data["REGISTRATION_STREET"] :
            data["RESIDENCY_STREET"];
          state.data.residenceAddress.house = residencyFill ?
            data["REGISTRATION_BUILDING"] :
            data["RESIDENCY_BUILDING"];
          state.data.residenceAddress.housing = residencyFill ?
            data["REGISTRATION_BUILDING_KORP"] :
            data["RESIDENCY_BUILDING_KORP"];
          state.data.residenceAddress.flat = residencyFill ?
            data["REGISTRATION_APARTMENT"] :
            data["RESIDENCY_APARTMENT"];
          state.data.residenceAddress.index = residencyFill ?
            data["REGISTRATION_INDEX"] :
            data["RESIDENCY_INDEX"];
          //_4
          state.data.agreementPD = data["SCAN_PD_CONSENT"];
          //_5
          if (!data['REPRESENTATIVE_BASIS'].value) {
            data['REPRESENTATIVE_BASIS'].value = "";
          }

          state.data.representativePerson.document = data['REPRESENTATIVE_BASIS'];
          state.data.representativePerson.lastname = data['REPRESENTATIVE_LASTNAME'];
          state.data.representativePerson.firstname = data['REPRESENTATIVE_NAME'];

          if (!data['REPRESENTATIVE_SECONDNAME'].value) {
            data['REPRESENTATIVE_SECONDNAME'].value = "";
          }

          state.data.representativePerson.surname = data['REPRESENTATIVE_SECONDNAME'];
          state.data.representativePerson.docType = data['REPRESENTATIVE_DOCUMENT_TYPE'];

          if (!data['REPRESENTATIVE_DOCUMENT_SERIAL'].value) {
            data['REPRESENTATIVE_DOCUMENT_SERIAL'].value = "";
          }

          state.data.representativePerson.serial = data['REPRESENTATIVE_DOCUMENT_SERIAL'];

          if (!data['REPRESENTATIVE_DOCUMENT_NUMBER'].value) {
            data['REPRESENTATIVE_DOCUMENT_NUMBER'].value = "";
          }

          state.data.representativePerson.number = data['REPRESENTATIVE_DOCUMENT_NUMBER'];

          if (!data['REPRESENTATIVE_PHONE'].value) {
            data['REPRESENTATIVE_PHONE'].value = "";
          }

          state.data.representativePerson.phone = data['REPRESENTATIVE_PHONE'];

          if (!data['REPRESENTATIVE_EMAIL'].value) {
            data['REPRESENTATIVE_EMAIL'].value = "";
          }

          state.data.representativePerson.email = data['REPRESENTATIVE_EMAIL'];
          state.data.representativePerson.country = data['REPRESENTATIVE_COUNTRY'];


          if (!data['REPRESENTATIVE_REGION'].value) {
            data['REPRESENTATIVE_REGION'].value = "";
          }

          state.data.representativePerson.region = data['REPRESENTATIVE_REGION'];
          state.data.representativePerson.city = data['REPRESENTATIVE_SETTLEMENT'];
          state.data.representativePerson.street = data['REPRESENTATIVE_STREET'];
          state.data.representativePerson.house = data['REPRESENTATIVE_BUILDING'];

          if (!data['REPRESENTATIVE_BUILDING_KORP'].value) {
            data['REPRESENTATIVE_BUILDING_KORP'].value = "";
          }

          state.data.representativePerson.housing = data['REPRESENTATIVE_BUILDING_KORP'];

          if (!data['REPRESENTATIVE_APARTMENT'].value) {
            data['REPRESENTATIVE_APARTMENT'].value = "";
          }

          state.data.representativePerson.flat = data['REPRESENTATIVE_APARTMENT'];
          state.data.representativePerson.index = data['REPRESENTATIVE_INDEX'];


          state.data.trustedPerson.lastname = data['ATTORNY_LASTNAME'];
          state.data.trustedPerson.firstname = data['ATTORNY_NAME'];

          if (!data['ATTORNY_SECONDNAME'].value) {
            data['ATTORNY_SECONDNAME'].value = "";
          }

          state.data.trustedPerson.surname = data['ATTORNY_SECONDNAME'];
          state.data.trustedPerson.docType = data['ATTORNY_DOCUMENT_TYPE'];

          if (!data['ATTORNY_DOCUMENT_SERIAL'].value) {
            data['ATTORNY_DOCUMENT_SERIAL'].value = "";
          }

          state.data.trustedPerson.serial = data['ATTORNY_DOCUMENT_SERIAL'];

          if (!data['ATTORNY_DOCUMENT_NUMBER'].value) {
            data['ATTORNY_DOCUMENT_NUMBER'].value = "";
          }

          state.data.trustedPerson.number = data['ATTORNY_DOCUMENT_NUMBER'];

          if (!data['ATTORNY_PHONE'].value) {
            data['ATTORNY_PHONE'].value = "";
          }

          state.data.trustedPerson.phone = data['ATTORNY_PHONE'];

          if (!data['ATTORNY_EMAIL'].value) {
            data['ATTORNY_EMAIL'].value = "";
          }

          state.data.trustedPerson.email = data['ATTORNY_EMAIL'];
          state.data.trustedPerson.country = data['ATTORNY_COUNTRY'];

          if (!data['ATTORNY_REGION'].value) {
            data['ATTORNY_REGION'].value = "";
          }

          state.data.trustedPerson.region = data['ATTORNY_REGION'];
          state.data.trustedPerson.city = data['ATTORNY_SETTLEMENT'];
          state.data.trustedPerson.street = data['ATTORNY_STREET'];
          state.data.trustedPerson.house = data['ATTORNY_BUILDING'];

          if (!data['ATTORNY_BUILDING_KORP'].value) {
            data['ATTORNY_BUILDING_KORP'].value = "";
          }

          state.data.trustedPerson.housing = data['ATTORNY_BUILDING_KORP'];

          if (!data['ATTORNY_APARTMENT'].value) {
            data['ATTORNY_APARTMENT'].value = "";
          }

          state.data.trustedPerson.flat = data['ATTORNY_APARTMENT'];
          state.data.trustedPerson.index = data['ATTORNY_INDEX'];
          break;
        case "step_2":
          state.data.maindata.personalPhoto = data['PERSONAL_PHOTO'];
          state.data.maindata.lastname = data["LAST_NAME"];
          state.data.maindata.firstname = data["NAME"];

          if (!data['SECOND_NAME'].value) {
            data['SECOND_NAME'].value = "";
          }

          state.data.maindata.surname = data["SECOND_NAME"];
          state.data.maindata.dateOfBirth = data["PERSONAL_BIRTHDAY"];
          state.data.maindata.sex = data["PERSONAL_GENDER"];

          if (!data['UF_SNILS'].value) {
            data['UF_SNILS'].value = "";
          }

          state.data.maindata.snils = data['UF_SNILS'];
          state.data.maindata.snilsFile = data['SCAN_SNILS'];

          if (!data['PERSONAL_MAILBOX'].value) {
            data['PERSONAL_MAILBOX'].value = "";
          }

          state.data.contacts.emailExtra = data['PERSONAL_MAILBOX'];

          if (!data['PERSONAL_MOBILE'].value) {
            data['PERSONAL_MOBILE'].value = "";
          }

          state.data.contacts.phoneHome = data['PERSONAL_MOBILE'];
          state.data.contacts.email = data['EMAIL'];
          state.data.contacts.phone = data['PERSONAL_PHONE'];
          state.data.maindata.snilsFile.value = state.data.maindata.snilsFile.value ? state.data.maindata.snilsFile.value : [];
          break;
        case "step_3":
          if (params.multipleBlocks.hasOwnProperty("no_before_docs")) {
            state.data.previousIdentity.length = 0
            params.multipleBlocks["no_before_docs"].map(param => {
              let serial = { value: "" }
              let number = { value: "" }
              let date = { value: "" }
              let scan = { value: [] }
              let type = { value: "" }
              let name = { value: "" };
              let lastName = { value: "" };
              let secondName = { value: "" };
              let citizenship = { value: "" }
              /*param.fieldValues.map((field) => {
                  field.code === "DOCUMENT_BEFORE_SERIAL" ?
                  serial = field.value :
                  ""
                  field.code === "DOCUMENT_BEFORE_NUMBER" ?
                  number = field.value :
                  ""
                  field.code === "DOCUMENT_BEFORE_DATE" ?
                  date = field.value :
                  ""
                  field.code === "DOCUMENT_BEFORE_SCAN" ?
                  scan = field.value :
                  ""
                  field.code === "DOCUMENT_BEFORE_TYPE" ?
                    type = field.value : "";
                  field.code === "DOCUMENT_PREVIOUS_CITIZENSHIP" ?
                    citizenship = field.value : "";
              }) */
              param.fieldValues.map((field) => {
                field.code === "DOCUMENT_BEFORE_SERIAL" ?
                  serial = field : "";
                field.code === "DOCUMENT_BEFORE_NUMBER" ?
                  number = field : "";
                field.code === "DOCUMENT_BEFORE_DATE" ?
                  date = field : "";
                field.code === "DOCUMENT_BEFORE_SCAN" ?
                  scan = field : "";
                field.code === "DOCUMENT_BEFORE_TYPE" ?
                  type = field : "";
                field.code === "DOCUMENT_PREVIOUS_CITIZENSHIP" ?
                  citizenship = field : "";
                field.code === "DOCUMENT_BEFORE_LAST_NAME" ?
                  lastName = (field.value ? field : state.data.maindata.lastname) : "";
                field.code === "DOCUMENT_BEFORE_NAME" ?
                  name = (field.value ? field : state.data.maindata.firstname) : "";
                field.code === "DOCUMENT_BEFORE_SECOND_NAME" ?
                  secondName = (field.value ? field : state.data.maindata.surname) : "";
              })
              state.data.previousIdentity.push({
                //"id": 0,
                "serial": serial,
                "number": number,
                "date": date,
                "docType": type,
                "citizenship": citizenship,
                "passportScan": scan,
                "firstname": name,
                "lastname": lastName,
                "surname": secondName
              })
            })
          }

          break;
        case "step_4":
          state.data.compatriot.length = []
          if (params.data.find((e) => e.code === 'IS_COPATRIOT')?.value && params.multipleBlocks.hasOwnProperty("copatriot")) {
            params.multipleBlocks["copatriot"].map(param => {
              let document = { value: "" };
              let serial = { value: "" };
              let number = { value: "" };
              let type = { value: "" };
              let date = { value: "" };
              let givenBy = { value: "" };
              let extraInfo = { value: "" };
              let scan = { value: [] };
              /*param.fieldValues.map((field) => {
                  field.code === "COPATRIOT_DOCUMENT" ?
                  document = field.value :
                  ""
                  field.code === "COPATRIOT_DOCUMENT_SERIAL" ?
                  serial = field.value :
                  ""
                  field.code === "COPATRIOT_DOCUMENT_NUMBER" ?
                  number = field.value :
                  ""
                  field.code === "COPATRIOT_DOCUMENT_TYPE" ?
                  type = field.value :
                  ""
                  field.code === "COPATRIOT_DOCUMENT_GIVENBY" ?
                  givenBy = field.value :
                  ""
                  field.code === "COPATRIOT_DESCRIPTION" ?
                  extraInfo = field.value :
                  ""
                  field.code === "COPATRIOT_SCAN" ?
                  scan = field.value :
                  ""
              })*/
              param.fieldValues.map((field) => {
                field.code === "COPATRIOT_DOCUMENT" ?
                  document = field : "";
                field.code === "COPATRIOT_DOCUMENT_SERIAL" ?
                  serial = field : "";
                field.code === "COPATRIOT_DOCUMENT_NUMBER" ?
                  number = field : "";
                field.code === "COPATRIOT_DOCUMENT_TYPE" ?
                  type = field : "";
                field.code === "COPATRIOT_DOCUMENT_GIVENBY" ?
                  givenBy = field : "";
                field.code === "COPATRIOT_DESCRIPTION" ?
                  extraInfo = field : "";
                field.code === "COPATRIOT_SCAN" ?
                  scan = field : "";
                field.code === "COPATRIOT_DOCUMENT_DATE" ?
                  date = field : "";
              })
              state.data.compatriot.push({
                //"id": 0,
                "document": document,
                "serial": serial,
                "number": number,
                "docType": type,
                "date": date,
                "givenBy": givenBy,
                "extraInfo": extraInfo,
                "documentScan": scan
              })
            })
          }
          break;
        case "step_5":
          if (data["EDUCATION_DOCUMENT_COUNTRY"].value) {
            /*const result = params.refs[data["EDUCATION_DOCUMENT_COUNTRY"].value] === params.rfId;
            if(result){*/
            if (data["EDUCATION_IS_HSE"].value) {
              state.data.eduDocuments.IsHse = data["EDUCATION_IS_HSE"];
            } else {
              state.data.eduDocuments.IsHse = { value: false };
            }
            state.data.eduDocuments.eduLevel = data["EDUCATION_LEVEL"];
            state.data.eduDocuments.givenCountry = data["EDUCATION_DOCUMENT_COUNTRY"];
            state.data.eduDocuments.docType = data["EDUCATION_DOCUMENT_TYPE"];
            state.data.eduDocuments.givenRegion = data["EDUCATION_DOCUMENT_REGION"];
            state.data.eduDocuments.givenLocation = data["EDUCATION_DOCUMENT_CITY"] ?? { value: '' };
            state.data.eduDocuments.date = data["EDUCATION_DOCUMENT_DATE"];

            if (!data['EDUCATION_DOCUMENT_SERIAL']?.value) {
              data['EDUCATION_DOCUMENT_SERIAL'] = { value: "" };
            }

            state.data.eduDocuments.serial = data["EDUCATION_DOCUMENT_SERIAL"];
            state.data.eduDocuments.number = data["EDUCATION_DOCUMENT_NUMBER"];
            state.data.eduDocuments.schoolType = data["EDUCATION_ORGANIZATION_TYPE"];
            state.data.eduDocuments.givenBy = data["EDUCATION_ORGANIZATION_NAME"];
            state.data.eduDocuments['score3'] = data["EDUCATION_SCORE_3"];
            state.data.eduDocuments['score4'] = data["EDUCATION_SCORE_4"];
            state.data.eduDocuments['score5'] = data["EDUCATION_SCORE_5"];
            if (data["EDUCATION_SCORE_3"]?.value || data["EDUCATION_SCORE_4"]?.value || data["EDUCATION_SCORE_5"]?.value) {
              const numberOfThree = data["EDUCATION_SCORE_3"]?.value ?
                Number(data["EDUCATION_SCORE_3"].value) :
                0
              const numberOfFour = data["EDUCATION_SCORE_4"]?.value ?
                Number(data["EDUCATION_SCORE_4"].value) :
                0
              const numberOfFive = data["EDUCATION_SCORE_5"]?.value ?
                Number(data["EDUCATION_SCORE_5"].value) :
                0
              const count = numberOfFive + numberOfFour + numberOfThree;
              state.data.eduDocuments.avgMark = { value: (numberOfThree * 3 + numberOfFour * 4 + numberOfFive * 5) / count }
            } else if (data["EDUCATION_WITH_HONORS"]?.value) {
              state.data.eduDocuments.avgMark = { value: 5 }
            }
            if (data["EDUCATION_WITH_HONORS"]?.value) {
              state.data.eduDocuments.honorsDoc = data["EDUCATION_WITH_HONORS"]
            }
            let mainLang = {
              GUIDLanguage: data["EDUCATION_FOREIGN_LANGUAGE"],
              IsMain: true
            };
            state.data.foreignLanguages = [mainLang];
            state.data.eduDocuments.eduDocFiles = data["EDUCATION_SCANS"]
            /* }
             else{*/
            state.data.nostrification.eduLevel = data["EDUCATION_LEVEL"];
            state.data.nostrification.givenCountry = data["EDUCATION_DOCUMENT_COUNTRY"];
            state.data.nostrification.GUIDLanguage = data["EDUCATION_DOCUMENT_LANGUAGE"];
            state.data.nostrification.date = data["EDUCATION_DOCUMENT_DATE"];

            if (!data['EDUCATION_DOCUMENT_SERIAL']?.value) {
              data['EDUCATION_DOCUMENT_SERIAL'] = { value: "" };
            }

            state.data.nostrification.serial = data["EDUCATION_DOCUMENT_SERIAL"];
            state.data.nostrification.number = data["EDUCATION_DOCUMENT_NUMBER"];


            if (!data['EDUCATION_RECOGNITION']?.value) {
              data['EDUCATION_RECOGNITION'] = { value: false };
            }

            state.data.nostrification.hasNostrification = data["EDUCATION_RECOGNITION"];

            state.data.nostrification.eduInstitutionType = data["EDUCATION_ORGANIZATION_FORM"];

            state.data.nostrification.docName = data["EDUCATION_DOCUMENT_NAME"];
            state.data.nostrification.docNameOrigin = data["EDUCATION_DOCUMENT_NAME_ORIGIN"]

            state.data.nostrification.studyDuration = data["EDUCATION_DURATION"];

            if (!data['EDUCATION_DEGREE_NAME']?.value) {
              data['EDUCATION_DEGREE_NAME'] = { value: "" };
            }

            state.data.nostrification.diplomaDegreeTitle = data["EDUCATION_DEGREE_NAME"];

            if (!data['EDUCATION_RIGHTS']?.value) {
              data['EDUCATION_RIGHTS'] = { value: "" };
            }

            state.data.nostrification.academicProfessionalRights = data["EDUCATION_RIGHTS"];

            if (!data['EDUCATION_PREVIOUS_FORM']?.value) {
              data['EDUCATION_PREVIOUS_FORM'] = { value: "" };
            }

            state.data.nostrification.prevEducationEduForm = data["EDUCATION_PREVIOUS_FORM"];
            state.data.nostrification.diplomaCertified = data['EDUCATION_SCAN_ORIGIN'];
            state.data.nostrification.diplomaCertifiedTranslation = data['EDUCATION_SCAN_TRANSLATION_RUSSIAN']
            state.data.nostrification.passportCertifiedTranslation = data['DOCUMENT_SCAN_TRANSLATION']
            state.data.nostrification.nostrificatedDiploma = data['EDUCATION_SCAN_RECOGNITION']
            state.data.nostrification.extraQualificationDocuments = data["EDUCATION_SCANS_EXT"]
            state.data.nostrification.extraNostificationDocuments = data["EDUCATION_SCAN_RECOGNITION_EXT"]
            // ???
            // state.data.nostrification. = data["EDUCATION_SCAN_ORIGIN"]
            // state.data.nostrification. = data["EDUCATION_SCAN_TRANSLATION_RUSSIAN"]
            // state.data.nostrification. = data["DOCUMENT_SCAN_TRANSLATION"]
            //}
          }
          break;
        case "step_6":
          if (params.multipleBlocks.hasOwnProperty("step_6_1")) {
            state.data.egeResults.length = 0
            params.multipleBlocks["step_6_1"].map(param => {
              let discipline = { value: "" }
              let score = { value: "" }
              let date = { value: "" }
              param.fieldValues.map((field) => {
                field.code === "EGE_DISCIPLINE" ?
                  discipline = field : "";
                field.code === "EGE_SCORE" ?
                  score = field : "";
                field.code === "EGE_DATE" ?
                  date = field : "";
              })
              state.data.egeResults.push({
                //"id": 0,
                "GUIDSubject": discipline,
                "Mark": score,
                "Year": date,
              })
            })
          }

          if (params.multipleBlocks.hasOwnProperty("step_6_2")) {
            state.data.CT.length = 0
            params.multipleBlocks["step_6_2"].map(param => {
              let discipline = { value: "" }
              let score = { value: "" }
              let date = { value: "" }
              let files = { value: [] }
              param.fieldValues.map((field) => {
                field.code === "TESTING_DISCIPLINE" ?
                  discipline = field : "";
                field.code === "TESTING_SCORE" ?
                  score = field : "";
                field.code === "TESTING_DATE" ?
                  date = field : "";
                field.code === "TESTING_SCAN" ?
                  files = field : "";
              })
              state.data.CT.push({
                //"id": 0,
                "GUIDSubject": discipline,
                "Mark": score,
                "Year": date,
                "CTFiles": files
              })
            })
          }
          break;
        case "step_7":
          state.data.olimpicDiplomas.length = 0;
          state.data.olimpicDiplomasInternational.length = 0;
          state.data.olimpicDiplomasUkraine.length = 0;
          if (params.multipleBlocks.hasOwnProperty("step_7_1")) {
            const DICTIONARY = {
              'OLYMPIAD_LIST_YEAR': 'OlympicDocOlympiadeYear',
              'OLYMPIAD_LIST_PROFILE': 'OlympicDocOlympiadeProfileGuid',
              'OLYMPIAD_LIST_OLYMPIAD': 'OlympicDocOlympiadeGuid',
              'OLYMPIAD_LIST_SUBJECT': 'OlympicDocOlympiadeDisciplineGuid',
              'OLYMPIAD_LIST_CLASS': 'OlympicDocOlympiadeClassGuid',
              'OLYMPIAD_LIST_RESULT': 'OlympicDocDiplomaTypeGuid',
              'OLYMPIAD_LIST_NUMBER': 'Number',
              'OLYMPIAD_LIST_DATE': 'Date',
              'OLYMPIAD_LIST_SCAN': 'FilePath',
            };
            params.multipleBlocks["step_7_1"].map(param => {
              let fields = {
                //id: 0,
                OlympicDocOlympiadeYear: { value: "" },
                OlympicDocOlympiadeProfileGuid: { value: "" },
                OlympicDocOlympiadeGuid: { value: "" },
                OlympicDocOlympiadeDisciplineGuid: { value: "" },
                OlympicDocOlympiadeClassGuid: { value: "" },
                OlympicDocDiplomaTypeGuid: { value: "" },
                Number: { value: "" },
                Date: { value: "" },
                FilePath: { value: [] },
                isRu: { value: false }
              }
              param.fieldValues.map((field) => {
                // console.log(field.code, '>>>');
                DICTIONARY.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY[field.code]] = field : { value: "" };
              })

              state.data.olimpicDiplomas.push(fields);
            })
          }
          if (params.multipleBlocks.hasOwnProperty("step_7_2")) {
            const DICTIONARY_RU = {
              'OLYMPIAD_RU_YEAR': 'OlympicDocOlympiadeYear',
              'OLYMPIAD_RU_PROFILE': 'OlympicDocOlympiadeProfileGuid',
              'OLYMPIAD_RU_OLYMPIAD': 'OlympicDocOlympiadeGuid',
              'OLYMPIAD_RU_CLASS': 'OlympicDocOlympiadeClassGuid',
              'OLYMPIAD_RU_RESULT': 'OlympicDocDiplomaTypeGuid',
              'OLYMPIAD_RU_NUMBER': 'Number',
              'OLYMPIAD_RU_DATE': 'Date',
              'OLYMPIAD_RU_SCAN': 'FilePath',
            };
            params.multipleBlocks["step_7_2"].map(param => {
              let fields = {
                //id: 0,
                OlympicDocOlympiadeYear: { value: "" },
                OlympicDocOlympiadeProfileGuid: { value: "" },
                OlympicDocOlympiadeGuid: { value: "" },
                OlympicDocOlympiadeDisciplineGuid: { value: "" },
                OlympicDocOlympiadeClassGuid: { value: "" },
                OlympicDocDiplomaTypeGuid: { value: "" },
                Number: { value: "" },
                Date: { value: "" },
                FilePath: { value: [] },
                isRu: { value: true }
              }
              param.fieldValues.map((field) => {
                DICTIONARY_RU.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY_RU[field.code]] = field : { value: "" };
              })

              state.data.olimpicDiplomas.push(fields);
            })
          }
          if (params.multipleBlocks.hasOwnProperty("step_7_3")) {
            const DICTIONARY_INTERNATIONAL = {
              'OLYMPIAD_INTERNATIONAL_YEAR': 'OlympicDocOlympiadeYear',
              'OLYMPIAD_INTERNATIONAL_PROFILE': 'OlympicDocOlympiadeProfileGuid',
              'OLYMPIAD_INTERNATIONAL_RESULT': 'OlympicDocDiplomaTypeGuid',
              'OLYMPIAD_INTERNATIONAL_TEAM': 'Country',
              'OLYMPIAD_INTERNATIONAL_NAME': 'OlympicName',
              'OLYMPIAD_INTERNATIONAL_DIPLOMA': 'Number',
              'OLYMPIAD_INTERNATIONAL_NUMBER': 'OlympicOrderNumber',
              'OLYMPIAD_INTERNATIONAL_DATE': 'OlympicDate',
              'OLYMPIAD_INTERNATIONAL_SCAN': 'FilePath',
            };
            params.multipleBlocks["step_7_3"].map(param => {
              let fields = {
                //id: 0,
                OlympicDocOlympiadeYear: { value: "" },
                OlympicDocOlympiadeProfileGuid: { value: "" },
                OlympicDocDiplomaTypeGuid: { value: "" },
                OlympicOrderNumber: { value: "" },
                Country: { value: "" },
                OlympicName: { value: "" },
                Number: { value: "" },
                OlympicDate: { value: "" },
                FilePath: { value: [] }
              }
              param.fieldValues.map((field) => {
                DICTIONARY_INTERNATIONAL.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY_INTERNATIONAL[field.code]] = field : { value: "" };
              })

              state.data.olimpicDiplomasInternational.push(fields);
            })
          }
          if (params.multipleBlocks.hasOwnProperty("step_7_4")) {
            const DICTIONARY_UKR = {
              'OLYMPIAD_UKR_YEAR': 'OlympicDocOlympiadeYear',
              'OLYMPIAD_UKR_PROFILE': 'OlympicDocOlympiadeProfileGuid',
              'OLYMPIAD_UKR_RESULT': 'OlympicDocDiplomaTypeGuid',
              'OLYMPIAD_UKR_NAME': 'OlympicName',
              'OLYMPIAD_UKR_NUMBER': 'Number',
              'OLYMPIAD_UKR_DATE': 'OlympicDate',
              'OLYMPIAD_UKR_SCAN': 'FilePath',
            };
            params.multipleBlocks["step_7_4"].map(param => {
              let fields = {
                //id: 0,
                OlympicDocOlympiadeYear: { value: "" },
                OlympicDocOlympiadeProfileGuid: { value: "" },
                OlympicDocDiplomaTypeGuid: { value: "" },
                OlympicName: { value: "" },
                Number: { value: "" },
                OlympicDate: { value: "" },
                FilePath: { value: [] }
              }
              param.fieldValues.map((field) => {
                DICTIONARY_UKR.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY_UKR[field.code]] = field : { value: "" };
              })

              state.data.olimpicDiplomasUkraine.push(fields);
            })
          }
          break;
        case "step_8":
          if (params.multipleBlocks.hasOwnProperty("step_8_1")) {
            state.data.personalAchievments.length = 0
            params.multipleBlocks["step_8_1"].map(param => {
              let category = { value: "" }
              let achievement = { value: "" }
              let document = { value: "" }
              let name = { value: "" }
              let number = { value: "" };
              let date = { value: "" }
              let scan = { value: [] };
              let givenBy = { value: "" };
              let comment = { value: "" };
              /*param.fieldValues.map((field) => {
                  field.code === "ACHIEVEMENT_CATHEGORY" ?
                  category = field.value :
                  ""
                  field.code === "ACHIEVEMENT_TYPE" ?
                  achievement = field.value :
                  ""
                  field.code === "ACHIEVEMENT_NAME" ?
                  name = field.value :
                  ""
                  field.code === "ACHIEVEMENT_NUMBER" ?
                  number = field.value :
                  0
                  field.code === "ACHIEVEMENT_DATE" ?
                  date = field.value :
                  ""
                  field.code === "ACHIEVEMENT_SCAN" ?
                  scan = field.value :
                  ""
                  field.code === "ACHIEVEMENT_GIVENBY" ?
                    givenBy = field.value : ""
              })*/
              param.fieldValues.map((field) => {
                field.code === "ACHIEVEMENT_CATHEGORY" ?
                  category = field : { value: "" };
                field.code === "ACHIEVEMENT_TYPE" ?
                  achievement = field : { value: "" };
                field.code === "ACHIEVEMENT_DOCUMENT" ?
                  //document = (field !== "" ? field : {value: ""}) : {value: ""};
                  document = field : { value: "" };
                field.code === "ACHIEVEMENT_NAME" ?
                  name = field : { value: "" };
                field.code === "ACHIEVEMENT_NUMBER" ?
                  number = field : { value: "" };
                field.code === "ACHIEVEMENT_DATE" ?
                  date = field : { value: "" };
                field.code === "ACHIEVEMENT_SCAN" ?
                  scan = field : { value: [] };
                field.code === "ACHIEVEMENT_GIVENBY" ?
                  givenBy = field : { value: "" };
                field.code === "ACHIEVEMENT_COMMENT" ?
                  comment = field : { value: "" }
              })
              state.data.personalAchievments.push({
                // вопрос
                //"id": 0,
                "IndividualAchievementGroupType": category,
                "IndividualAchievementDocType": document,
                "givenBy": givenBy,
                "IndividualAchievementGuid": achievement,
                "Number": number,
                "Date": date,
                "FilePath": scan,
                "Comment": comment,
              })
            })
          }
          break;
        case "step_9":
          state.data.specialQuota.length = 0;
          state.data.ldnrQuota.length = 0;
          state.data.extraQuota.length = 0;
          state.data.newRegionRf = [];
          state.data.newRegionScanAgree = null;

          if (params.multipleBlocks.hasOwnProperty("benefit")) {
            if (data['BENEFIT_HAVE'].value) {
              const DICTIONARY = {
                'BENEFIT_TYPE': 'benefitTypeGuid',
                'BENEFIT_DISABILITY_DOCUMENT': 'benefitHandicapDocGuid',
                'BENEFIT_DISABILITY_GROUP': 'benefitHandicapGroup',
                'BENEFIT_CATEGORY': 'benefitHandicapCategory',
                'BENEFIT_DISABILITY_COMMENT': 'comment',
                'BENEFIT_ORPHANAGE_DOCUMENT': 'benefitOrphanageDocGuid',
                'BENEFIT_ORPHANAGE_CATEGORY': 'benefitOrphanageCategory',
                'BENEFIT_COMBANANT_DOCUMENT': 'benefitCombanantDocGuid',
                'BENEFIT_COMBANANT_CATEGORY': 'benefitCombanantCategory',
                'BENEFIT_SERIAL': 'Serial',
                'BENEFIT_NUMBER': 'Number',
                'BENEFIT_DATE_FROM': 'dateFrom',
                'BENEFIT_DATE_TO': 'dateTill',
                'BENEFIT_DATE_INDEFINITELY': 'datePerpetual',
                'BENEFIT_ORGANIZATION': 'givenBy',
                'BENEFIT_CHECKBOX': 'countAsPriority',
                'BENEFIT_SCAN_BIRTH': 'birthCertificate',
                'BENEFIT_SCAN': 'FilePath',
              };
              params.multipleBlocks["benefit"].map(param => {
                let fields = {
                  benefitTypeGuid: { value: "" },
                  benefitHandicapDocGuid: { value: "" },
                  benefitHandicapGroup: { value: "" },
                  benefitHandicapCategory: { value: "" },
                  comment: { value: "" },
                  benefitOrphanageDocGuid: { value: "" },
                  benefitOrphanageCategory: { value: "" },
                  benefitCombanantDocGuid: { value: "" },
                  benefitCombanantCategory: { value: "" },
                  Serial: { value: "" },
                  Number: { value: "" },
                  dateFrom: { value: "" },
                  dateTill: { value: "" },
                  datePerpetual: { value: false },
                  givenBy: { value: "" },
                  countAsPriority: { value: false },
                  birthCertificate: { value: "" },
                  FilePath: { value: [] },
                };

                param.fieldValues.map((field) => {
                  DICTIONARY.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY[field.code]] = field : "";
                })

                state.data.specialQuota.push(fields);
              })
            } else {
              state.data.specialQuota = []
            }
          }

          if (params.multipleBlocks.hasOwnProperty("ldnr_fields")) {
            if (data['HAVE_LDNR'].value) {
              const DICTIONARY = {
                'LDNR_CATEGORY': 'benefitTypeGuid',
                'LDNR_SERIAL': 'Serial',
                'LDNR_NUMBER': 'Number',
                'LDNR_DATE': 'dateFrom',
                'LDNR_ORGANIZATION': 'givenBy',
                'LDNR_SCAN': 'FilePath',
                'LDNR_DOC_TYPE': 'benefitDocTypeGuid'
              };
              params.multipleBlocks["ldnr_fields"].map(param => {
                let fields = {
                  benefitTypeGuid: { value: "" },
                  benefitDocTypeGuid: { value: "" },
                  Serial: { value: "" },
                  Number: { value: "" },
                  dateFrom: { value: "" },
                  givenBy: { value: "" },
                  FilePath: { value: [] }
                };

                param.fieldValues.map((field) => {
                  DICTIONARY.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY[field.code]] = field : "";
                })

                state.data.ldnrQuota.push(fields);
              })
            }
          }

          if (params.multipleBlocks.hasOwnProperty("specquota_fields")) {
            if (data['HAVE_SPECIAL_QUOTA'].value) {
              const DICTIONARY = {
                'SQ_CATEGORY': 'benefitTypeGuid',
                'SQ_SERIAL': 'Serial',
                'SQ_NUMBER': 'Number',
                'SQ_DATE': 'dateFrom',
                'SQ_ORGANIZATION': 'givenBy',
                'SQ_SCAN': 'FilePath',
                'SQ_DOC_TYPE': 'benefitDocTypeGuid'
              };
              params.multipleBlocks["specquota_fields"].map(param => {
                let fields = {
                  benefitTypeGuid: { value: "" },
                  benefitDocTypeGuid: { value: "" },
                  Serial: { value: "" },
                  Number: { value: "" },
                  dateFrom: { value: "" },
                  givenBy: { value: "" },
                  FilePath: { value: [] }
                };

                param.fieldValues.map((field) => {
                  DICTIONARY.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY[field.code]] = field : "";
                })

                state.data.extraQuota.push(fields);
              })
            } else {
              state.data.extraQuota = []
            }
          }

          if (data['HAVE_NEW_REGION_RF']?.value) {
            state.data.newRegionScanAgree = data['NEW_REGION_RF_AGREE_SCAN']
            if (params.multipleBlocks.hasOwnProperty('new_region_rf')) {
              const DICTIONARY = {
                'NEW_REGION_RF_NAME': 'Name',
                'NEW_REGION_RF_NUMBER': 'Number',
                'NEW_REGION_RF_DATE': 'dateFrom',
                'NEW_REGION_RF_GIVENBY': 'givenBy',
                'NEW_REGION_RF_CATEGORY': 'benefitTypeGuid',
                'NEW_REGION_RF_SCAN': 'FilePath',
              };



              params.multipleBlocks.new_region_rf.map(param => {
                let fields = {
                  Name: { value: "" },
                  Number: { value: "" },
                  dateFrom: { value: "" },
                  benefitTypeGuid: { value: "" },
                  givenBy: { value: "" },
                  FilePath: { value: [] }
                };

                param.fieldValues.map((field) => {
                  DICTIONARY.hasOwnProperty(field.code) && field.value ? fields[DICTIONARY[field.code]] = field : "";
                })
                state.data.newRegionRf.push(fields);
              })
            }
          }
          break;
        case "step_10":
          state.data.priorityRights = []
          // условие открытия чекбокса
          if (data["PREEMPTIVE_HAVE"]?.value) {
            if (params.multipleBlocks.hasOwnProperty("preemtive")) {
              params.multipleBlocks["preemtive"].map(param => {
                let type = { value: "" }
                let document = { value: "" }
                let serial = { value: "" }
                let number = { value: "" }
                let date = { value: "" }
                let givenBy = { value: "" }
                let scan = { value: [] }
                /*param.fieldValues.map((field) => {
                    field.code === "PREEMPTIVE_TYPE" ?
                    title = field.value :
                    ""
                    field.code === "PREEMPTIVE_DOCUMENT" ?
                    type = field.value :
                    ""
                    field.code === "PREEMPTIVE_SERIAL" ?
                    serial = field.value :
                    ""
                    field.code === "PREEMPTIVE_NUMBER" ?
                    number = field.value :
                    0
                    field.code === "PREEMPTIVE_DATE" ?
                    date = field.value :
                    ""
                    field.code === "PREEMPTIVE_GIVENBY" ?
                    givenBy = field.value :
                    ""
                    field.code === "PREEMPTIVE_SCAN" ?
                    scan = field.value :
                    ""
                })*/
                param.fieldValues.map((field) => {
                  /*field.code === "PREEMPTIVE_CATEGORY" ?
                    category = field : "";*/
                  field.code === "PREEMPTIVE_TYPE" ?
                    type = field : "";
                  field.code === "PREEMPTIVE_DOCUMENT" ?
                    document = field : "";
                  field.code === "PREEMPTIVE_SERIAL" ?
                    serial = field : "";
                  field.code === "PREEMPTIVE_NUMBER" ?
                    number = field : "";
                  field.code === "PREEMPTIVE_DATE" ?
                    date = field : "";
                  field.code === "PREEMPTIVE_GIVENBY" ?
                    givenBy = field : "";
                  field.code === "PREEMPTIVE_SCAN" ?
                    scan = field : "";
                })
                state.data.priorityRights.push({
                  //"id": 0,
                  "benefitTypeGuid": type,
                  //"benefitCategory": type,
                  "benefitDocType": document,
                  "Serial": serial,
                  "Number": number,
                  "Date": date,
                  "givenBy": givenBy,
                  "FilePath": scan,
                })
              })
            }
          }
          break;
        case "step_11":
          if (data["LIFT_HAVE"]?.value) {
            state.data.socialElevator.isApplicable = { value: data["LIFT_HAVE"].value && data["LIFT_SCAN"].value && data["LIFT_SCAN"].value.length > 0 };
            state.data.socialElevator.FilePath = data["LIFT_HAVE"].value ? data["LIFT_SCAN"] : { value: [] };
            state.data.socialElevator.LiftCatogory = data["LIFT_HAVE"].value ? data["LIFT_CATEGORIES"] : { value: [] }
          } else {
            state.data.socialElevator = {
              isApplicable: false
            }
          }
          break;
        case "step_12":
          state.data.targetedEducation = []
          // условие
          if (data['TARGETED_HAVE']?.value) {
            if (params.multipleBlocks.hasOwnProperty("targeted")) {
              params.multipleBlocks["targeted"].map(param => {
                let number = { value: "" }
                let date = { value: "" }
                let company = { value: "" }
                let region = { value: "" }
                let customer = { value: "" }
                let direction = { value: "" }
                let program = { value: "" }
                let campus = { value: "" }
                let comment = { value: "" }
                let scan = { value: [] }
                /*param.fieldValues.map((field) => {
                    field.code === "TARGETED_NUMBER" ?
                    number = field.value :
                    ""
                    field.code === "TARGETED_DATE" ?
                    date = field.value :
                    ""
                    field.code === "TARGETED_ORGANIZATION" ?
                    company = field.value :
                    ""
                    field.code === "TARGETED_REGION" ?
                    region = field.value :
                    0
                    field.code === 'TARGETED_CUSTUMER_NAME' ?
                    customer = field.value :
                    ""
                    field.code === "TARGETED_DIRECTION" ?
                    direction = field.value :
                    ""
                    field.code === "TARGETED_PROGRAM" ?
                    program = field.value :
                    ""
                    field.code === "TARGETED_CAMPUS" ?
                    campus = field.value :
                    ""
                    field.code === "TARGETED_DESCRIPTION" ?
                    comment = field.value :
                    ""
                    field.code === "TARGETED_SCAN" ?
                    scan = field.value :
                    ""
                })*/

                param.fieldValues.map((field) => {
                  field.code === "TARGETED_NUMBER" ?
                    number = field : { value: "" };
                  field.code === "TARGETED_DATE" ?
                    date = field : [];
                  field.code === "TARGETED_ORGANIZATION" ?
                    company = field : { value: "" };
                  field.code === "TARGETED_REGION" ?
                    region = field : { value: "" };
                  field.code === 'TARGETED_CUSTUMER_NAME' ?
                    customer = field : { value: "" };
                  field.code === "TARGETED_DIRECTION" ?
                    direction = field : { value: "" };
                  field.code === "TARGETED_PROGRAM" ?
                    program = field : { value: "" };
                  field.code === "TARGETED_CAMPUS" ?
                    campus = field : { value: "" };
                  field.code === "TARGETED_DESCRIPTION" ?
                    comment = field : { value: "" };
                  field.code === "TARGETED_SCAN" ?
                    scan = field : { value: "" };
                })

                if (Array.isArray(direction?.value) && direction.value.length) {
                  let tempSet = new Set();
                  direction.value.map((e) => e.toString()).forEach((e) => tempSet.add(e));
                  direction.value = Array.from(tempSet.values())
                }
                state.data.targetedEducation.push({
                  //"id": 0,
                  "contractNumber": number,
                  "contractDate": date,
                  "contractCompany": company,
                  "regionCompany": region,
                  "customerCompany": customer,
                  "contractEduField": direction,
                  "contractEduProgram": program,
                  "contractCampus": campus,
                  "comment": comment,
                  "FilePath": scan,
                })
              })
            }
          }
          break;
        case "step_13":
          if (params.multipleBlocks.hasOwnProperty("step_13_1")) {
            state.data.contactPersons.length = 0
            params.multipleBlocks["step_13_1"].map(param => {
              let type = { value: "" }
              let fullName = { value: "" }
              let phone = { value: "" }
              let email = { value: "" }
              let lastName = { value: "" }
              let name = { value: "" }
              let secondName = { value: "" }
              /*param.fieldValues.map((field) => {

                  field.code === "CONTACT_PERSON" ?
                  type = field.value :
                  ""
                  field.code === "CONTACT_PHONE" ?
                  phone = field.value :
                  ""
                  field.code === "CONTACT_EMAIL" ?
                  email = field.value :
                  ""
                  field.code === "CONTACT_LAST_NAME" ?
                  lastName = field.value :
                  ""
                  field.code === "CONTACT_FIRST_NAME" ?
                  name = field.value :
                  ""
                  field.code === "CONTACT_SECOND_NAME" ?
                  secondName = field.value :
                  ""

                  fullName = lastName + ' ' + name + ' ' + secondName
              })*/
              param.fieldValues.map((field) => {
                field.code === "CONTACT_PERSON" ?
                  type = field : "";
                field.code === "CONTACT_PHONE" ?
                  phone = field : "";
                field.code === "CONTACT_EMAIL" ?
                  email = field : "";
                field.code === "CONTACT_LAST_NAME" ?
                  lastName = field : "";
                field.code === "CONTACT_FIRST_NAME" ?
                  name = field : "";
                field.code === "CONTACT_SECOND_NAME" ?
                  secondName = field : "";

                fullName = lastName.value + ' ' + name.value + ' ' + secondName.value
              })
              state.data.contactPersons.push({
                //"id": 0,
                "GUIDRelationType": type,
                "FIO": { value: fullName },
                "Tel": phone,
                "Email": email,
                "lastName": lastName,
                "name": name,
                "secondName": secondName
              })
            })
          }
          break;
        case "step_14":
          state.data.competiveGroup.length = 0;
          let selected = this.getters['application/getSelectedCompetitionGroup'];
          // let newLastStepFields = [];
          // let campuses = {};
          let fieldsForms = new Map()
          let types = [];

          const setFieldForm = (key, nameField) => {
            fieldsForms.set(key, {
              title: nameField,
              type: key,
              value: '',
              code: "BRANCH_SCAN_" + key.toUpperCase(),
            })
          }

          const addFieldsForms = (item) => {
            item.types?.forEach((e) => {
              if (e.selected) {
                if (e.type !== 'commerce') {
                  setFieldForm('budgetary', 'Заявление по бюджетной основе')
                } else {
                  setFieldForm('commerce', 'Заявление по коммерческой основе')
                }
                // TODO: Формы для скачивания РЭШ
                // if (e.isRes) {
                //   setFieldForm('application_res', 'Заявление о приеме в Российскую экономическую школу (РЭШ)')
                //   setFieldForm('gdpr_res', 'Согласие на обработку персональных данных')
                // }
              }
            })
          }
          selected.forEach(item => {
            if (!fieldsForms.has('budgetary') || !fieldsForms.has('commerce') || !fieldsForms.has('application_res')) {
              addFieldsForms(item)
            }
            // const arrPlaceTypes = []
            // if (!(Object.keys(campuses).includes(item.campusId))) {
            //   item?.types.forEach((e) => {
            //     if (e.selected && !arrPlaceTypes.includes(e.type)) {
            //       arrPlaceTypes.push(e.type)
            //     }
            //   })

            //   campuses[item.campusId] = {
            //     placeTypes: arrPlaceTypes,
            //     name: item.campus ?? ''
            //   };
            // }
            item.types.forEach(type => {
              if (type.selected) {
                const benefitLabel = 'Особая квота';
                const targetedLabel = 'Целевое';
                const extraLabel = 'Отдельная квота';
                //console.log('check >>>>>>>', type.label, type.label === benefitLabel, type.label === targetedLabel);
                types.push(type.id);
                //console.log(type);
                state.data.competiveGroup.push({
                  "GUIDCompetitiveGroup": {
                    value: type.id,
                    type: 'select'
                  },
                  "Specialization": {
                    value: type.specialisation ? type.specialisation : "",
                    type: 'select'
                  },
                  "eduProgram": {
                    value: type.eduProgram ? type.eduProgram : "",
                    type: 'select'
                  },
                  "specialQuotaDoc": type.label === benefitLabel && type.blockId ? { value: type.blockId } : false,
                  "extraQuotaDoc": type.label === extraLabel && type.blockId ? { value: type.blockId } : false,
                  "targetedEducationDoc": type.label === targetedLabel && type.blockId ? { value: type.blockId } : false,
                  "benefitNoExam": false,
                  "benefitNoExamQuota": false,
                  "benefitNoExamQuotaSet": type.label === extraLabel,
                  "benefitHundredPoints": false
                })
              }
            })
          });
          //console.log(campuses);
          // for (let campusId in campuses) {
          //   let newElement = {};
          //   newElement.title = `НИУ ВШЭ ${campuses[campusId].name}`;
          //   newElement.campus = Number(campusId);
          //   newElement.value = "";
          //   newElement.code = "BRANCH_SCAN_" + campusId
          //   newElement.placeTypes = campuses[campusId]?.placeTypes ?? []
          //   newLastStepFields.push(newElement);
          // }
          if (fieldsForms.size > 0) {
            this.dispatch('application/updateLastStepBlockFields', Array.from(fieldsForms.values()));
          }
          // this.dispatch('application/updateTrialsDisciplines', types);
          break;
        case "step_15":
          // console.log('..................... step_15 .....................');
          /** @type {ModelItemInterface[]} */
          let privilegesModel = this.getters['step-15/getModel']; // this.$store.getters['step-15/getModel'];
          /** @type {{
           * cgIndex: number, bweIndex: number,
           * bweInstance: {id: number | undefined, olympiad: OlympiadInterface, selected: boolean},
           * typeId: number,
           * } | boolean} */
          let selectedBwe = this.getters['step-15/getSelectedBwe'];

          state.data.competiveGroup?.forEach((e, i) => {
            if (selectedBwe && selectedBwe.cgIndex === i) {
              e.benefitNoExam = { value: selectedBwe.bweInstance.id };
            } else {
              e.benefitNoExam = false
            }
          })

          let models = this.getters['multiBlocks/getMultipleBlocks'];
          const extraQuotaTypeGuid = this.getters['application/getGuidExtraQuotaType'];
          let quotaBwet = false;
          const REFS = this.getters['application/getRefs'];
          if (models.hasOwnProperty('specquota_fields')) {
            for (let i = 0; i < models['specquota_fields'].length; i++) {
              let block = models['specquota_fields'][i];
              let findIndex = block.fieldValues.findIndex(field => field.code === 'SQ_CATEGORY');
              if (findIndex !== -1) {
                const FIELD_VALUE = block.fieldValues[findIndex].value;
                const REFS_VALUE = REFS[FIELD_VALUE];
                if (REFS_VALUE === extraQuotaTypeGuid) {
                  quotaBwet = block.id;
                  break;
                }
              }
            }
          }
          for (let i = 0; i < state.data.competiveGroup.length; i += 1) {
            const privilegesByDisciplines = privilegesModel[i]?.privilegesByDisciplines;
            if (privilegesByDisciplines) {
              let hunderPoints = []
              for (const discipline of privilegesByDisciplines) {
                for (const olympiad of discipline.olympiads) {
                  if (olympiad.selected) {
                    hunderPoints.push({
                      value: olympiad.id
                    })
                    // state.data.competiveGroup[i].benefitHundredPoints = { value: olympiad.id };
                  }
                }
              }
              if (hunderPoints.length) {
                if (selectedBwe && privilegesModel[i].type?.id === selectedBwe.typeId) {
                  hunderPoints = hunderPoints.filter((e) => e.value !== selectedBwe.bweInstance.id);
                }
                state.data.competiveGroup[i].benefitHundredPoints = hunderPoints;
              } else {
                state.data.competiveGroup[i].benefitHundredPoints = false;
              }
              if (state.data.competiveGroup[i].benefitNoExamQuotaSet) {
                state.data.competiveGroup[i].benefitNoExamQuota = { value: quotaBwet };
              }
              delete state.data.competiveGroup[i].benefitNoExamQuotaSet;
            } else {
              state.data.competiveGroup[i].benefitHundredPoints = false;
            }
          }

          // console.log(state.data.competiveGroup);
          // console.log(privilegesModel);
          break;
        case "step_17":
          if (data["ET_HAVE"].value) {
            state.data.innerExams.docExamRights = data["ET_BASIS"]
            state.data.innerExams.fileExamRights = data["ET_SCAN"]
            state.data.innerExams.chosenDisciplines.length = []
            if (data['ET_DISCIPLINE'].value) {
              state.data.innerExams.chosenDisciplines = data['ET_DISCIPLINE'];
            }
            /*
              if(data["ET_DISCIPLINE_RL"].value){
                  state.data.innerExams.chosenDisciplines.push(data["ET_DISCIPLINE_RL"])
              }
              if(data["ET_DISCIPLINE_IKT"].value){
                  state.data.innerExams.chosenDisciplines.push(data["ET_DISCIPLINE_IKT"])
              }
              if(data["ET_DISCIPLINE_PHYSICS"].value){
                  state.data.innerExams.chosenDisciplines.push(data["ET_DISCIPLINE_PHYSICS"])
              }
              if(data["ET_DISCIPLINE_MATH"].value){
                  state.data.innerExams.chosenDisciplines.push(data["ET_DISCIPLINE_MATH"])
              }
            */
          } else {
            state.data.innerExams.chosenDisciplines = [];
            state.data.innerExams.docExamRights = { value: "" };
            state.data.innerExams.fileExamRights = { value: [] };
          }
          let creativeET = this.getters['application/getCreativeET'];
          if (creativeET.length) {
            const valueResult = Array.isArray(state.data.innerExams.chosenDisciplines?.value) ? state.data.innerExams.chosenDisciplines?.value?.concat(creativeET) : creativeET;
            state.data.innerExams.chosenDisciplines.value = valueResult;
          }
          if (data["LH_HAVE"].value) {
            state.data.innerExams.isHandicaped = data["LH_HAVE"]
            state.data.innerExams.handicape = data["LH_BASIS"]
            state.data.innerExams.handicapeType = data["LH_TYPE"]
            state.data.innerExams.handicapeDisorderType = data["LH_DISEASE"]
            state.data.innerExams.handicapeCategory = data["LH_CATEGORY"]
            state.data.innerExams.handicapeDocumentType = data["LH_DOCUMENT"]
            state.data.innerExams.handicapeSerial = data["LH_SERIAL"]
            state.data.innerExams.handicapeNumber = data["LH_NUMBER"]
            state.data.innerExams.handicapeDateFrom = data["LH_DATE_FROM"]
            state.data.innerExams.handicapeDateTill = data["LH_DATE_TO"]
            if (data["LH_DATE_INDEFINITELY"].value) {
              state.data.innerExams.handicapeDatePerpetual = data["LH_DATE_INDEFINITELY"]
            }

            state.data.innerExams.handicapeGivenBy = data["LH_ORGANIZATION"]
            state.data.innerExams.handicapeDoc = data["LH_SCAN"]
          } else {
            state.data.innerExams.isHandicaped = { value: false };
            state.data.innerExams.handicape = { value: "" };
            state.data.innerExams.handicapeType = { value: "" };
            state.data.innerExams.handicapeDisorderType = { value: "" };
            state.data.innerExams.handicapeCategory = { value: "" };
            state.data.innerExams.handicapeDocumentType = { value: "" };
            state.data.innerExams.handicapeSerial = { value: "" };
            state.data.innerExams.handicapeNumber = { value: "" };
            state.data.innerExams.handicapeDateFrom = { value: "" };
            state.data.innerExams.handicapeDateTill = { value: "" };
            state.data.innerExams.handicapeDatePerpetual = { value: false };
            state.data.innerExams.handicapeGivenBy = { value: "" };
            state.data.innerExams.handicapeDoc = { value: [] };
          }

          if (data["SC_HAVE"].value) {
            state.data.innerExams.specialConditionsRequired = data["SC_HAVE"]
            if (data["SC_BASIS"].value) {
              state.data.innerExams.specialConditionsHandicape = data["SC_BASIS"]
            }
          } else {
            state.data.innerExams.specialConditionsRequired = { value: false };
            state.data.innerExams.specialConditionsHandicape = { value: "" };
          }
          break;
        case "step_18":
          state.data.otherInfo.NeedHostel = { value: data['HSE_HOSTEL']?.value || false };
          if (data["HSE_BRANCH"] && state.data.otherInfo.NeedHostel.value && data['HSE_BRANCH'].value.length) {
            state.data.otherInfo.HostelCampus = data['HSE_BRANCH'];
          } else {
            state.data.otherInfo.HostelCampus = { value: [] };
          }
          if (data['NEED_ALT_HOSTEL']) {
            state.data.otherInfo.NeedAltHostel = data['NEED_ALT_HOSTEL']
          }
          if (!data["HSE_PLUS_SUBMIT"].value) {
            data["HSE_PLUS_SUBMIT"].value = false;
          }
          state.data.otherInfo.HsePlus = data["HSE_PLUS_SUBMIT"];

          if (data["EPGU_SUBMIT"].value) {
            state.data.otherInfo.epguAgreement = data["EPGU_SUBMIT"];
          } else {
            state.data.otherInfo.epguAgreement = { value: false };
          }
          break;
        case "step_19":
          const lastStepFields = this.getters['application/getLastStepFields'];
          state.data.applicationPrintForm.length = 0;
          lastStepFields.forEach(field => {
            state.data.applicationPrintForm.push({
              "placeType": {
                value: field.placeType
              },
              "FilePath": {
                type: 'form_scan',
                value: field.value
              }
            });
          })
          break;
      }
    }
  },
  setId(state, params) {
    state.id = params.id
  },
  setPriorityAgree(state, value) {
    state.isPriorityAgree = value ?? false
  },
  setPriorityPlace(state, params) {
    state.data.priorityPlace = params
  },
  setChangePriorityPlace(state, params) {
    state.isChangedPriorityPlace = params ?? false
  },
  SET_ERROR(state, error) {
    if (error === null) {
      state.finalStepValidationErrors = null
    } else {
      state.finalStepValidationErrors = {
        text: error.message,
        reasons: []
      }
      if (Array.isArray(error)) {
        error.data.forEach(item => state.finalStepValidationErrors.reasons.push(item.property + ': ' + item.message))
      }
    }
  },
  SET_STATE_SEND(state, param) {
    state.isSendsData = param ?? false
  },
  SET_STATUS(state, params) {
    state.status = params
  },
  SET_FIELD_STEP(state, param) {
    if (!state.fieldsStep[param.field]) {
      state.fieldsStep[param.field] = param.value;
    }
  }
}

export const getters = {
  getData: (state) => {
    return state.data
  },
  getTargetedEdication: (state) => {
    return state.data['targetedEducation'] ?? []
  },
  getStepByField: (state) => (field) => {
    for (const [key, value] of Object.entries(state.fieldsStep)) {
      if (field && typeof field === 'string' && value.find((e) => field.includes(e))) {
        return key;
      }
    }
    return ''
  },
  getCGFilterArray: (state, getters, rootState, rootGetters) => {
    let nowDate = new Date();
    let arFilter = {
      "PROPERTY_EXTRA_QUOTA": false,
      "PROPERTY_TARGET": false,
      "PROPERTY_SPECIAL_QUOTA": false,
      'ACTIVE': 'Y',
      "!PROPERTY_CAMPUS": false,
      "!PROPERTY_SPECIALITY_CODE": false,
      "PROPERTY_FOR_FOREIGNERS": false
    };
    if (state.data.specialQuota && state.data.specialQuota.length > 0) {
      delete arFilter['PROPERTY_SPECIAL_QUOTA'];
    }
    if (state.data.ldnrQuota && state.data.ldnrQuota.length > 0 ||
      state.data.extraQuota && state.data.extraQuota.length > 0) {
      delete arFilter['PROPERTY_EXTRA_QUOTA'];
    }
    if (state.data.targetedEducation && state.data.targetedEducation.length > 0) {
      let multiblocks = rootGetters['multiBlocks/getMultipleBlocks'];
      let subFilter = {};
      if (multiblocks.hasOwnProperty("targeted")) {
        multiblocks['targeted'].map(param => {
          let filter = {};
          param.fieldValues.map(field => {
            field.code === "TARGETED_CAMPUS" ? filter['PROPERTY_CAMPUS'] = field.value : "";
            field.code === "TARGETED_PROGRAM" ? filter['PROPERTY_EDU_PROGRAM'] = field.value : "";
            field.code === "TARGETED_DIRECTION" ? filter['PROPERTY_SPECIALITY'] = field.value : "";
          });
          filter['!PROPERTY_TARGET'] = false;
          subFilter[Object.keys(subFilter).length] = filter;
        });
      }
      if (Object.keys(subFilter).length > 0) {
        subFilter['LOGIC'] = "OR";
        subFilter[Object.keys(subFilter).length] = { 'PROPERTY_TARGET': false };
      }
      delete arFilter['PROPERTY_TARGET'];
      arFilter[0] = subFilter;
    }
    const refs = rootGetters['application/getRefs'];
    if (state.data.identity.citizenship && refs[state.data.identity.citizenship.value] !== rootGetters['application/getRFGuid']) {
      delete arFilter['PROPERTY_FOR_FOREIGNERS'];
    }
    return arFilter;
  },
  getFinalStepErrors: (state) => {
    return state.finalStepValidationErrors
  },
  getPriorityPlace: (state) => {
    return state.data?.priorityPlace ?? null
  },
  priorityPlaceIsEmpty: (state) => {
    if (!state.data?.priorityPlace) {
      return true
    }
    if (!state.data.priorityPlace.commercePriority?.length && !state.data.priorityPlace.budgetPriority?.length) {
      return true
    }
    return false
  },
  priorityPlaceIsUnknown: (state) => {
    if (state.data.priorityPlace?.unknownPriority?.length) {
      return true
    }
    return false
  },
  getStatus: (state) => {
    return state.status
  },
  getStateSend: (state) => {
    return state.isSendsData
  },
  isSocialElevator(state) {
    return state.data?.socialElevator?.isApplicable?.value ?? false
  },
}
